(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-careers"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-section-type="careers"]');
    if (!sections.length) return;

    var isIOS = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (!isIOS) return;

    sections.forEach(function(section) {
      var iframeContainer = section.querySelector('[data-careers-iframe]');
      var fallback = section.querySelector('[data-careers-fallback]');
      if (iframeContainer && fallback) {
        iframeContainer.classList.add('hidden');
        fallback.classList.remove('hidden');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-section-type="faq"]');
    sections.forEach(function(section) {
      var toggles = section.querySelectorAll('.faq-toggle');
      toggles.forEach(function(toggle) {
        toggle.addEventListener('click', function() {
          var item = this.closest('.faq-item');
          var answer = item.querySelector('.faq-answer');
          var isOpen = item.classList.contains('faq-open');

          // Close all other items in this section
          var allItems = section.querySelectorAll('.faq-item');
          allItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('faq-open');
              var otherAnswer = otherItem.querySelector('.faq-answer');
              otherAnswer.style.maxHeight = '0';
              otherItem.querySelector('.faq-toggle').setAttribute('aria-expanded', 'false');
            }
          });

          // Toggle current item
          if (isOpen) {
            item.classList.remove('faq-open');
            answer.style.maxHeight = '0';
            this.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('faq-open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            this.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-404"]) return;
  try {
    
  (function() {
    var form = document.querySelector('.template-404 form[action="/collections/shop"]');
    if (!form) return;

    var input = form.querySelector('input[name="q"]');
    var clearBtn = form.querySelector('.404-search-clear');
    if (!input || !clearBtn) return;

    input.addEventListener('input', function() {
      clearBtn.style.opacity = input.value.length ? '1' : '0';
    });

    clearBtn.addEventListener('click', function() {
      input.value = '';
      clearBtn.style.opacity = '0';
      input.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-account"]) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.marketing-section');
    sections.forEach(function(section) {
      var btn = section.querySelector('.marketing-toggle-btn');
      if (!btn) return;

      var customerId = section.getAttribute('data-customer-id');
      var subscribed = section.getAttribute('data-subscribed') === 'true';

      var labels = {
        subscribe: section.dataset.labelSubscribe || 'Subscribe',
        unsubscribe: section.dataset.labelUnsubscribe || 'Unsubscribe',
        subscribed: section.dataset.labelSubscribed || '',
        notSubscribed: section.dataset.labelNotSubscribed || ''
      };
      var benefitsSubTmpl = section.querySelector('[data-benefits-subscribed]');
      var benefitsUnsubTmpl = section.querySelector('[data-benefits-unsubscribed]');

      btn.addEventListener('click', function() {
        var newState = !subscribed;
        btn.textContent = '...';
        btn.disabled = true;

        fetch('https://australia-southeast1-cable-dotapparel21-au.cloudfunctions.net/customerMarketingConsent-productionPreview', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'shop': window.Shopify.shop.replace('.myshopify.com', '')
          },
          body: JSON.stringify({
            id: parseInt(customerId),
            emailMarketingConsent: {
              marketingOptInLevel: newState ? 'SINGLE_OPT_IN' : null,
              marketingState: newState ? 'SUBSCRIBED' : 'UNSUBSCRIBED',
              consentUpdatedAt: new Date().toISOString()
            }
          })
        }).then(function() {
          subscribed = newState;
          btn.textContent = subscribed ? labels.unsubscribe : labels.subscribe;
          btn.disabled = false;

          var statusText = section.querySelector('.marketing-status-text');
          var benefitsText = section.querySelector('.marketing-benefits-text');
          if (statusText) {
            statusText.textContent = subscribed ? labels.subscribed : labels.notSubscribed;
          }
          if (benefitsText) {
            benefitsText.innerHTML = subscribed
              ? (benefitsSubTmpl ? benefitsSubTmpl.innerHTML : '')
              : (benefitsUnsubTmpl ? benefitsUnsubTmpl.innerHTML : '');
          }
        }).catch(function() {
          btn.textContent = subscribed ? labels.unsubscribe : labels.subscribe;
          btn.disabled = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-addresses"]) return;
  try {
    
  (function() {
    var provinces = {
      'Australia': [
        'Australian Capital Territory', 'New South Wales', 'Northern Territory',
        'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia'
      ],
      'New Zealand': [
        'Auckland', 'Bay of Plenty', 'Canterbury', 'Gisborne', 'Hawke\'s Bay',
        'Manawatu-Wanganui', 'Marlborough', 'Nelson', 'Northland', 'Otago',
        'Southland', 'Taranaki', 'Tasman', 'Waikato', 'Wellington', 'West Coast'
      ]
    };

    var addressList = document.getElementById('addresses-list');
    var addBtns = document.querySelectorAll('.address-add-btn');
    var editBtns = document.querySelectorAll('.address-edit-btn');
    var cancelBtns = document.querySelectorAll('.address-cancel-btn');

    function hideAllForms() {
      document.querySelectorAll('[id^="address-form-"]').forEach(function(form) {
        form.classList.add('hidden');
      });
      if (addressList) addressList.classList.remove('hidden');
    }

    function showForm(formId) {
      hideAllForms();
      if (addressList) addressList.classList.add('hidden');
      var form = document.getElementById(formId);
      if (form) form.classList.remove('hidden');
    }

    addBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        showForm('address-form-new');
      });
    });

    editBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var addressId = this.getAttribute('data-address-id');
        showForm('address-form-' + addressId);
      });
    });

    cancelBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        hideAllForms();
      });
    });

    function populateProvinces(countrySelect) {
      var provinceTargetId = countrySelect.getAttribute('data-province-target');
      var provinceSelect = document.getElementById(provinceTargetId);
      if (!provinceSelect) return;

      var country = countrySelect.value;
      var list = provinces[country] || [];
      var currentProvince = countrySelect.getAttribute('data-current-province') || '';

      provinceSelect.innerHTML = '';
      list.forEach(function(p) {
        var opt = document.createElement('option');
        opt.value = p;
        opt.textContent = p;
        if (p === currentProvince) opt.selected = true;
        provinceSelect.appendChild(opt);
      });
    }

    document.querySelectorAll('.address-country-select').forEach(function(select) {
      populateProvinces(select);
      select.addEventListener('change', function() {
        this.removeAttribute('data-current-province');
        populateProvinces(this);
      });
    });

    document.querySelectorAll('.address-phone-tooltip-trigger').forEach(function(trigger) {
      var tooltip = trigger.parentElement.querySelector('.address-phone-tooltip');
      if (!tooltip) return;
      trigger.addEventListener('mouseenter', function() { tooltip.classList.remove('hidden'); });
      trigger.addEventListener('mouseleave', function() { tooltip.classList.add('hidden'); });
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        tooltip.classList.toggle('hidden');
      });
    });

    document.querySelectorAll('.address-default-checkbox').forEach(function(checkbox) {
      var label = checkbox.closest('label');
      if (!label) return;
      var activeIcon = label.querySelector('.address-default-active');
      var inactiveIcon = label.querySelector('.address-default-inactive');
      label.addEventListener('click', function(e) {
        e.preventDefault();
        checkbox.checked = !checkbox.checked;
        activeIcon.classList.toggle('hidden', !checkbox.checked);
        inactiveIcon.classList.toggle('hidden', checkbox.checked);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-blog"]) return;
  try {
    
  (function() {
    // --- Hero Slider ---

    function initHeroSlider() {
      const el = document.getElementById('blogHeroSlider');
      if (!el) return;

      const splide = new Splide(el, {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        speed: 500,
        arrows: true,
        pagination: true,
      });

      splide.mount();

      // Replace default Splide arrow SVGs with our custom icon arrows
      const prevBtn = el.querySelector('.splide__arrow--prev');
      const nextBtn = el.querySelector('.splide__arrow--next');
      if (prevBtn) {
        prevBtn.innerHTML = '<svg width="30" height="19" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" transform="translate(-4 -7)" fill-rule="evenodd" d="M6.216 11.5h12.789c.273 0 .495.224.495.5s-.222.5-.495.5H6.215l3.138 3.139a.506.506 0 0 1-.357.861.506.506 0 0 1-.357-.147l-3.992-3.997a.505.505 0 0 1 0-.712L8.64 7.648a.503.503 0 1 1 .714.713L6.216 11.5z"/></svg>';
      }
      if (nextBtn) {
        nextBtn.innerHTML = '<svg width="30" height="19" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" transform="matrix(-1 0 0 1 20 -7)" fill-rule="evenodd" d="M6.216 11.5h12.789c.273 0 .495.224.495.5s-.222.5-.495.5H6.215l3.138 3.139a.506.506 0 0 1-.357.861.506.506 0 0 1-.357-.147l-3.992-3.997a.505.505 0 0 1 0-.712L8.64 7.648a.503.503 0 1 1 .714.713L6.216 11.5z"/></svg>';
      }
    }

    // --- Most Read Slider ---

    function initMostReadSlider() {
      const el = document.getElementById('blogMostReadSlider');
      if (!el) return;

      const slideCount = el.querySelectorAll('.splide__slide').length;

      const splide = new Splide(el, {
        type: 'slide',
        perPage: Math.min(slideCount, 6),
        perMove: 2,
        arrows: false,
        pagination: false,
        speed: 1000,
        gap: '0px',
        breakpoints: {
          992: {
            perPage: 3,
          },
        },
      });

      splide.mount();

      // Wire up custom PREV/NEXT buttons
      const prevBtn = document.querySelector('.mostread-arrow--prev');
      const nextBtn = document.querySelector('.mostread-arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', function() { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function() { splide.go('>'); });
    }

    // --- Load More Pagination ---

    function initLoadMore() {
      const container = document.getElementById('blogLoadMore');
      const btn = document.getElementById('blogLoadMoreBtn');
      const grid = document.getElementById('blogArticleGrid');
      const spinner = document.getElementById('blogLoadMoreSpinner');

      if (!container || !btn || !grid) return;

      let currentPage = parseInt(container.dataset.currentPage || '1', 10);
      const totalPages = parseInt(container.dataset.totalPages || '1', 10);
      const blogUrl = container.dataset.blogUrl || '';

      btn.addEventListener('click', async function() {
        if (currentPage >= totalPages) return;

        currentPage++;
        btn.style.display = 'none';
        if (spinner) spinner.classList.remove('hidden');

        try {
          const url = blogUrl + '?view=json&page=' + currentPage;
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.statusText);

          const html = await response.text();
          const temp = document.createElement('div');
          temp.innerHTML = html;

          // The ?view=json response wraps the article columns in a
          // .shopify-section element. Append the inner columns (not the
          // wrapper) so they flow as flex items in the grid rather than
          // stacking in a single block / left-aligned column.
          const sectionWrap = temp.querySelector('.shopify-section');
          const source = sectionWrap || temp;
          while (source.firstChild) {
            grid.appendChild(source.firstChild);
          }

          if (spinner) spinner.classList.add('hidden');

          if (currentPage < totalPages) {
            btn.style.display = '';
          }
        } catch (e) {
          console.error('Load more failed:', e);
          if (spinner) spinner.classList.add('hidden');
          btn.style.display = '';
        }
      });
    }

    // --- Blog Navigation Mobile Toggle ---

    function initBlogNavToggle() {
      const toggle = document.getElementById('blogNavToggle');
      const mobileNav = document.getElementById('mobileNav');
      const blogNav = document.querySelector('.blog-nav');
      const mobileNavMenu = document.querySelector('.mobile-nav__menu');

      if (!toggle || !mobileNav) return;

      toggle.addEventListener('click', function() {
        if (mobileNav.style.display === 'block') {
          mobileNav.style.display = 'none';
          if (blogNav) blogNav.style.borderBottom = '1px solid rgb(230 230 230)';
          if (mobileNavMenu) mobileNavMenu.style.borderBottom = 'none';
        } else {
          mobileNav.style.display = 'block';
          if (blogNav) blogNav.style.borderBottom = 'none';
          if (mobileNavMenu) mobileNavMenu.style.borderBottom = '1px solid rgb(230 230 230)';
        }
      });
    }

    // --- Init ---

    function init() {
      initHeroSlider();
      initMostReadSlider();
      initLoadMore();
      initBlogNavToggle();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-cart"]) return;
  try {
    
  (function() {
    var gtm = window.Gazman && window.Gazman.gtm;

    // Local cart data cache - updated on every cart:updated event
    var currentCartData = window.Gazman ? window.Gazman.cartData : null;
    document.addEventListener('cart:updated', function(e) {
      currentCartData = e.detail;
    });

    var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
    function cartChange(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: key, quantity: qty }),
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
    }

    function cartAdd(variantId, qty, properties) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: variantId, quantity: qty || 1, properties: properties || {} }),
      })
      .then(function(res) { if (!res.ok) throw new Error(res.statusText); })
      .then(function() {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
    }

    function isCartPage() {
      var cartUrl = document.getElementById('cart-page').dataset.cartUrl || '/cart';
      return window.location.pathname === cartUrl;
    }

    function replaceCartPageHTML(target, html) {
      const template = document.createElement('template');
      template.innerHTML = html;
      target.innerHTML = '';
      target.appendChild(template.content.cloneNode(true));
    }

    /**
     * Fetch fresh cart section HTML via Section Rendering API
     * and swap the #cart-page container contents.
     */
    async function refreshCartSection() {
      try {
        const res = await fetch(window.location.pathname + '?sections=template-cart,dynamic-donation');
        const data = await res.json();

        // Refresh main cart section
        const cartHTML = data['template-cart'];
        if (cartHTML) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(cartHTML, 'text/html');
          const newContent = doc.getElementById('cart-page');
          const current = document.getElementById('cart-page');
          if (newContent && current) {
            replaceCartPageHTML(current, newContent.innerHTML);
            if (window.Gazman && window.Gazman.initNostoPlacements) {
              requestAnimationFrame(window.Gazman.initNostoPlacements);
            }
          }
        }

        // Refresh donation section
        const donationHTML = data['dynamic-donation'];
        if (donationHTML) {
          const donationContainer = document.getElementById('donation-section');
          if (donationContainer) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(donationHTML, 'text/html');
            const newDonation = doc.getElementById('donation-section');
            if (newDonation) {
              replaceCartPageHTML(donationContainer, newDonation.innerHTML);
            }
          }
        }
      } catch (err) {
        // Fallback: full page reload if section rendering fails
        window.location.reload();
      }
    }

    /**
     * Handle quantity change from a select dropdown
     */
    async function handleQtyChange(select) {
      const key = select.dataset.key;
      const qty = parseInt(select.value, 10);
      if (!key) return;

      // Add loading state to the cart item row
      const row = select.closest('[data-cart-item]');
      if (row) {
        row.classList.add('opacity-75', 'pointer-events-none');
      }

      try {
        // If qty is 0, treat as remove
        if (qty === 0) {
          await handleRemoveByKey(key, row);
          return;
        }

        await cartChange(key, qty);
        await refreshCartSection();
      } catch (err) {
        // Restore state on error
        if (row) {
          row.classList.remove('opacity-75', 'pointer-events-none');
        }
      }
    }

    /**
     * Handle remove item
     */
    async function handleRemove(button) {
      const key = button.dataset.key;
      if (!key) return;

      const row = button.closest('[data-cart-item]');
      await handleRemoveByKey(key, row);
    }

    async function handleRemoveByKey(key, row) {
      if (row) {
        row.classList.add('opacity-75', 'pointer-events-none');
      }

      try {
        // Fire GTM tracking before removing, but do not block the cart update if tracking fails.
        try {
          const cartData = currentCartData;
          const tracker = window.Gazman && window.Gazman.gtm && window.Gazman.gtm.trackRemoveFromCart;
          if (tracker && cartData && cartData.items) {
            const lineitem = cartData.items.find(function(item) { return item.key === key; });
            if (lineitem) {
              tracker(lineitem);
            }
          }
        } catch (err) { /* ignore tracking errors */ }

        await cartChange(key, 0);
        await refreshCartSection();
      } catch (err) {
        if (row) {
          row.classList.remove('opacity-75', 'pointer-events-none');
        }
      }
    }

    /**
     * Donation: add donation variant to cart
     */
    async function addDonation(variantId) {
      try {
        await cartAdd(variantId, 1, { _donation: 'true' });
        await refreshCartSection();
      } catch (err) {
        // Silent fail - donation is optional
      }
    }

    /**
     * Donation: remove donation from cart
     */
    async function removeDonation() {
      const cartData = currentCartData;
      if (!cartData || !cartData.items) return;

      const donationItem = cartData.items.find(function(item) {
        return item.properties && item.properties._donation === 'true';
      });

      if (donationItem) {
        await cartChange(donationItem.key, 0);
      }
    }

    /**
     * Handle donation toggle button click
     */
    async function handleDonationToggle(container) {
      const select = container.querySelector('[data-donation-select]');
      if (!select) return;

      const variantId = parseInt(select.value, 10);
      if (!variantId) return;

      // Check if donation is currently in cart
      const cartData = currentCartData;
      const hasDonation = cartData && cartData.items && cartData.items.some(function(item) {
        return item.properties && item.properties._donation === 'true';
      });

      if (hasDonation) {
        // Remove existing donation
        await removeDonation();
        await refreshCartSection();
      } else {
        // Add selected donation
        await addDonation(variantId);
      }
    }

    /**
     * Handle donation select change - if donation already in cart, swap variant
     */
    async function handleDonationSelectChange(container, newVariantId) {
      const cartData = currentCartData;
      const hasDonation = cartData && cartData.items && cartData.items.some(function(item) {
        return item.properties && item.properties._donation === 'true';
      });

      if (hasDonation) {
        // Remove old, add new
        await removeDonation();
        await addDonation(newVariantId);
      }
    }

    /**
     * Main event delegation for cart page interactions
     */
    function handleClick(e) {
      if (!isCartPage()) return;

      const target = e.target;

      // Continue shopping: return to the previous page the shopper was on, matching
      // the live site. Only intercept when there is in-site history to go back to;
      // otherwise fall through to the link's href fallback (the products collection).
      const continueLink = target.closest('[data-action="cart-continue-shopping"]');
      if (continueLink) {
        if (window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
        return;
      }

      // Remove button
      const removeBtn = target.closest('[data-action="cart-page-remove"]');
      if (removeBtn) {
        e.preventDefault();
        handleRemove(removeBtn);
        return;
      }

      // Donation toggle
      const donationToggle = target.closest('[data-donation-toggle]');
      if (donationToggle) {
        e.preventDefault();
        const container = donationToggle.closest('[data-donation]');
        if (container) {
          handleDonationToggle(container);
        }
        return;
      }
    }

    function handleChange(e) {
      if (!isCartPage()) return;

      const target = e.target;

      // Quantity select change
      if (target.matches('[data-action="cart-page-qty"]')) {
        e.preventDefault();
        handleQtyChange(target);
        return;
      }

      // Donation select change
      if (target.matches('[data-donation-select]')) {
        const container = target.closest('[data-donation]');
        const variantId = parseInt(target.value, 10);
        if (container && variantId) {
          handleDonationSelectChange(container, variantId);
        }
        return;
      }
    }

    function init() {
      if (!isCartPage()) return;

      document.addEventListener('click', handleClick);
      document.addEventListener('change', handleChange);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection"]) return;
  try {
    
(function() {
  // ====================================================================
  // Collection module (wishlist + GTM tracking)
  // ====================================================================

  // --- Wishlist ---

  var wishlistProducts = [];

  function fetchWishlist() {
    if (!window._swat) return;

    window._swat.fetch(function(products) {
      wishlistProducts = products;
      updateAllWishlistIcons();
    });
  }

  function updateAllWishlistIcons() {
    var cards = document.querySelectorAll('[data-action="wishlist-toggle"]');
    cards.forEach(function(card) {
      var productId = Number(card.dataset.productId);
      var isInWishlist = wishlistProducts.some(
        function(p) { return p.epi === productId || p.empi === productId; }
      );
      var starEmpty = card.querySelector('.js-wishlist-star');
      var starFilled = card.querySelector('.js-wishlist-star-filled');
      if (starEmpty && starFilled) {
        starEmpty.classList.toggle('hidden', isInWishlist);
        starFilled.classList.toggle('hidden', !isInWishlist);
      }
    });
  }

  function handleWishlistToggle(btn) {
    var productId = Number(btn.dataset.productId);
    var variantId = Number(btn.dataset.variantId) || productId;
    var isInWishlist = wishlistProducts.some(
      function(p) { return p.epi === variantId || p.empi === productId; }
    );

    // If SWYM has attached to this button, let SWYM handle the click entirely
    // (SWYM manages its own swym-added class which controls star visibility via CSS)
    if (btn.classList.contains('swym-loaded')) return;

    // Optimistic visual toggle for fallback path only
    var starEmpty = btn.querySelector('.js-wishlist-star');
    var starFilled = btn.querySelector('.js-wishlist-star-filled');
    if (starEmpty && starFilled) {
      starEmpty.classList.toggle('hidden', !isInWishlist);
      starFilled.classList.toggle('hidden', isInWishlist);
    }

    // Fallback: manually call SWYM API if it hasn't auto-attached
    var swat = window._swat;
    if (!swat) return;

    var pageData = {
      epi: variantId,
      empi: productId,
      du: (btn.dataset.productUrl && btn.dataset.productUrl.indexOf('http') !== 0) ? window.location.origin + btn.dataset.productUrl : (btn.dataset.productUrl || ''),
      dt: btn.dataset.productTitle || '',
      iu: btn.dataset.productImage || '',
      pr: Number(btn.dataset.productPrice) / 100,
      et: 4,
    };

    var onComplete = function() {
      fetchWishlist();
      document.dispatchEvent(new CustomEvent('swym:wishlist-updated'));
    };

    if (!isInWishlist) {
      swat.addToWishList(pageData, onComplete);
    } else {
      swat.removeFromWishList(pageData, onComplete);
    }
  }

  function bindWishlistButtons() {
    // Use event delegation so dynamically created elements (Splide clones) also work
    // Do NOT stopPropagation -- SWYM's native handler must also fire
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action="wishlist-toggle"]');
      if (!btn) return;
      e.preventDefault();
      handleWishlistToggle(btn);
    });
  }

  // --- GTM Tracking ---

  var trackedProducts = new WeakSet();

  function buildProductSeo(card, position) {
    var tags = (card.dataset.productTags || '').split(',');
    var colourTag = tags.find(function(t) { return t.startsWith('x-colour:'); });
    var colour = colourTag ? colourTag.split(':')[1] : undefined;
    var sale = '';
    var discount = tags.find(function(t) { return t.includes('flag:'); });
    if (discount) {
      var offer = discount.split('flag:')[1];
      sale = offer || '';
    }
    var price = Number(card.dataset.productPrice) || 0;

    return {
      name: card.dataset.productTitle || '',
      id: card.dataset.productSku || '',
      brand: card.dataset.productVendor || '',
      category: card.dataset.productType || '',
      list: 'Collection',
      position: position,
      price: price / 100,
      variant: colour,
      dimension12: price > 0 ? 'In Stock' : 'Out of Stock',
      dimension13: sale,
    };
  }

  function getCurrency() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency) || 'AUD';
  }

  function trackImpressions() {
    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var card = entry.target;
          if (trackedProducts.has(card)) return;
          trackedProducts.add(card);

          var cards = Array.from(document.querySelectorAll('[data-product-card]'));
          var position = cards.indexOf(card) + 1;
          var product = buildProductSeo(card, position);

          if (window.Gazman && window.Gazman.gtm) {
            window.Gazman.gtm.trackImpression(product, getCurrency(), 'Collection');
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('[data-product-card]').forEach(function(card) {
      observer.observe(card);
    });
  }

  function trackProductClicks() {
    document.querySelectorAll('[data-product-card]').forEach(function(card, index) {
      card.addEventListener('click', function() {
        var product = buildProductSeo(card, index + 1);
        if (window.Gazman && window.Gazman.gtm) {
          window.Gazman.gtm.trackProductClick(product, getCurrency(), 'Collection');
        }
      });
    });
  }

  // --- Collection Init ---

  function collectionInit() {
    bindWishlistButtons();
    trackImpressions();
    trackProductClicks();

    // Wishlist: wait for Swym to load
    var tryFetch = function() {
      if (window._swat) {
        fetchWishlist();
      } else {
        setTimeout(tryFetch, 1000);
      }
    };
    tryFetch();
  }

  // ====================================================================
  // Collection filters module (AJAX filtering, sorting, pagination)
  // ====================================================================

  // section.id of this template's collection section (e.g. "template--123__main").
  // Read from a meta tag because this JS lives in a javascript block where Liquid
  // is not rendered. The Section Rendering API needs the template-scoped section id (not
  // the section file name) to include this template's blocks - i.e. the inline banners -
  // in AJAX swaps. Falls back to the file name for safety.
  var _sectionIdMeta = document.querySelector('meta[name="collection-section-id"]');
  var SECTION_ID = (_sectionIdMeta && _sectionIdMeta.getAttribute('content')) || 'template-collection';

  // --- Section Rendering API ---

  var fetchController = null;

  function fetchAndSwap(url) {
    // Abort any in-flight request
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    var sectionEl = document.querySelector('[data-collection-section]');
    if (!sectionEl) return Promise.resolve();

    // Add loading state to grid only (not the filter drawer)
    var gridWrap = sectionEl.querySelector('[data-collection-grid-wrap]');
    if (gridWrap) {
      gridWrap.classList.add('opacity-50');
      gridWrap.style.pointerEvents = 'none';
    }

    // Build section rendering URL
    var fetchUrl = new URL(url, window.location.origin);
    // Always enforce in-stock filter
    var availVals = fetchUrl.searchParams.getAll('filter.v.availability');
    if (availVals.indexOf('1') === -1) {
      fetchUrl.searchParams.append('filter.v.availability', '1');
    }
    fetchUrl.searchParams.set('section_id', SECTION_ID);

    return fetch(fetchUrl.toString(), {
      signal: fetchController.signal,
    }).then(function(response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    }).then(function(html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      // Extract new content from the fetched section HTML
      var newSection = temp.querySelector('[data-collection-section]');
      if (!newSection) throw new Error('Section not found in response');

      // Preserve sidebar open/close state
      var sidebar = document.querySelector('[data-filters-sidebar]');
      var sidebarHidden = sidebar ? sidebar.style.visibility === 'hidden' : false;

      // Preserve mobile drawer open state
      var mobileFilter = document.querySelector('[data-filters-mobile-wrap] [data-collection-filters]');
      var mobileDrawerOpen = mobileFilter ? mobileFilter.classList.contains('is-open') : false;

      // Swap individual regions to preserve sidebar toggle state
      swapRegion('[data-collection-toolbar-wrap]', sectionEl, newSection);
      swapRegion('[data-collection-grid-wrap]', sectionEl, newSection);
      swapRegion('[data-collection-pagination-wrap]', sectionEl, newSection);
      swapRegion('[data-filters-desktop-wrap]', sectionEl, newSection);
      swapRegion('[data-filters-mobile-wrap]', sectionEl, newSection);

      // Restore sidebar state
      var newSidebar = document.querySelector('[data-filters-sidebar]');
      if (newSidebar && sidebarHidden) {
        newSidebar.style.width = '0';
        newSidebar.style.opacity = '0';
        newSidebar.style.visibility = 'hidden';
      }

      // Restore mobile drawer open state
      if (mobileDrawerOpen) {
        var newMobileFilter = document.querySelector('[data-filters-mobile-wrap] [data-collection-filters]');
        if (newMobileFilter) {
          newMobileFilter.classList.add('is-open');
          newMobileFilter.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      }

      // Update URL without reload
      var cleanUrl = new URL(url, window.location.origin);
      cleanUrl.searchParams.delete('section_id');
      window.history.pushState({}, '', cleanUrl.toString());

      // Re-initialize all event listeners on new DOM
      reinit();
    }).catch(function(err) {
      if (err.name === 'AbortError') return;
      // On error, fall back to full page navigation
      window.location.href = url;
    }).finally(function() {
      if (gridWrap) {
        gridWrap.classList.remove('opacity-50');
        gridWrap.style.pointerEvents = '';
      }
      fetchController = null;
    });
  }

  function swapRegion(selector, currentRoot, newRoot) {
    var current = currentRoot.querySelector(selector);
    var replacement = newRoot.querySelector(selector);
    if (current && replacement) {
      current.innerHTML = replacement.innerHTML;
    }
  }

  // --- Filter Drawer / Sidebar ---

  function initFilterDrawer() {
    var toggleBtns = document.querySelectorAll('[data-filters-toggle]');
    var filterEls = document.querySelectorAll('[data-collection-filters]');
    var closeBtns = document.querySelectorAll('[data-filters-close]');
    var backdrops = document.querySelectorAll('[data-filters-backdrop]');
    var sidebar = document.querySelector('[data-filters-sidebar]');
    var gridWrap = document.querySelector('[data-collection-grid-wrap]');

    function isDesktop() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    function updateToggleText(expanded) {
      var textEls = document.querySelectorAll('[data-filters-toggle-text]');
      textEls.forEach(function(el) {
        el.textContent = expanded ? 'Hide Filters' : 'Show Filters';
      });
    }

    function openFilters() {
      if (isDesktop()) {
        if (sidebar) {
          sidebar.style.width = '243px';
          sidebar.style.opacity = '';
          sidebar.style.visibility = '';
        }
        if (gridWrap) {
          gridWrap.classList.add('lg:pl-3');
        }
      } else {
        filterEls.forEach(function(el) {
          el.setAttribute('aria-hidden', 'false');
          el.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
      }
      toggleBtns.forEach(function(btn) { btn.setAttribute('aria-expanded', 'true'); });
      updateToggleText(true);
    }

    function closeFilters() {
      if (isDesktop()) {
        if (sidebar) {
          sidebar.style.width = '0';
          sidebar.style.opacity = '0';
          sidebar.style.visibility = 'hidden';
        }
        if (gridWrap) {
          gridWrap.classList.remove('lg:pl-3');
        }
      } else {
        filterEls.forEach(function(el) {
          el.setAttribute('aria-hidden', 'true');
          el.classList.remove('is-open');
        });
        document.body.style.overflow = '';
      }
      toggleBtns.forEach(function(btn) { btn.setAttribute('aria-expanded', 'false'); });
      updateToggleText(false);
    }

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeFilters();
        } else {
          openFilters();
        }
      });
    });

    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeFilters); });
    backdrops.forEach(function(el) { el.addEventListener('click', closeFilters); });

    // A11y: Escape closes mobile filter drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !isDesktop()) {
        var isOpen = false;
        filterEls.forEach(function(el) {
          if (el.classList.contains('is-open')) isOpen = true;
        });
        if (isOpen) closeFilters();
      }
    });

    // Sync toggle button state to actual filter visibility for the current viewport
    function syncToggleState() {
      var expanded;
      if (isDesktop()) {
        expanded = sidebar ? sidebar.style.visibility !== 'hidden' : true;
      } else {
        expanded = false;
        filterEls.forEach(function(el) {
          if (el.classList.contains('is-open')) expanded = true;
        });
      }
      toggleBtns.forEach(function(btn) {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      updateToggleText(expanded);
    }

    syncToggleState();

    // Re-sync when viewport crosses the lg breakpoint
    var lgMql = window.matchMedia('(min-width: 1024px)');
    if (lgMql.addEventListener) {
      lgMql.addEventListener('change', syncToggleState);
    } else if (lgMql.addListener) {
      lgMql.addListener(syncToggleState);
    }
  }

  // --- Filter Form ---

  function initFilterForm() {
    var forms = document.querySelectorAll('[data-collection-filter-form]');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        applyFilters(form);
      });

      // Apply button inside the form (mobile)
      var applyBtn = form.querySelector('[data-filters-apply]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function(e) {
          e.preventDefault();
          applyFilters(form);
        });
      }

      // Auto-apply on checkbox change (instant filter)
      form.querySelectorAll('[data-filter-input]').forEach(function(input) {
        input.addEventListener('change', function() {
          applyFilters(form);
        });
      });
    });
  }

  // Ensure the availability filter is always present in a URLSearchParams set
  function ensureAvailabilityFilter(params) {
    var hasAvail = false;
    var values = params.getAll('filter.v.availability');
    for (var i = 0; i < values.length; i++) {
      if (values[i] === '1') { hasAvail = true; break; }
    }
    if (!hasAvail) {
      params.append('filter.v.availability', '1');
    }
    return params;
  }

  function applyFilters(form) {
    var formData = new FormData(form);
    var params = new URLSearchParams();

    // Preserve existing sort_by and per_page
    var currentParams = new URLSearchParams(window.location.search);
    var sortBy = currentParams.get('sort_by');
    if (sortBy) {
      params.set('sort_by', sortBy);
    }
    var perPage = currentParams.get('per_page');
    if (perPage) {
      params.set('per_page', perPage);
    }

    // Build filter params from form checkboxes and inputs
    formData.forEach(function(value, name) {
      var strValue = String(value).trim();
      if (strValue !== '') {
        params.append(name, strValue);
      }
    });

    ensureAvailabilityFilter(params);
    var url = window.location.pathname + '?' + params.toString();
    fetchAndSwap(url);
  }

  // --- Sort ---

  function initSort() {
    var selects = document.querySelectorAll('[data-sort-select]');

    selects.forEach(function(select) {
      select.addEventListener('change', function() {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', select.value);
        ensureAvailabilityFilter(params);
        fetchAndSwap(window.location.pathname + '?' + params.toString());
      });
    });
  }

  // --- Per Page (JS-only: appends extra pages via Section Rendering API) ---

  function getServerPageSize() {
    var meta = document.querySelector('meta[name="collection-page-size"]');
    var v = meta ? parseInt(meta.getAttribute('content'), 10) : 0;
    return v > 0 ? v : 30;
  }

  function getRequestedPerPage() {
    var params = new URLSearchParams(window.location.search);
    var val = parseInt(params.get('per_page'), 10);
    if (val === 60 || val === 90) return val;
    return getServerPageSize();
  }

  function setPerPageDropdownValue(value) {
    document.querySelectorAll('[data-perpage-select]').forEach(function(select) {
      if (select.value !== String(value)) select.value = String(value);
    });
  }

  function initPerPage() {
    document.querySelectorAll('[data-perpage-select]').forEach(function(select) {
      var desired = String(getRequestedPerPage());
      if (select.value !== desired) select.value = desired;
      select.addEventListener('change', function() {
        var params = new URLSearchParams(window.location.search);
        var defaultSize = String(getServerPageSize());
        if (select.value === defaultSize) {
          params.delete('per_page');
        } else {
          params.set('per_page', select.value);
        }
        params.delete('page');
        var qs = params.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    });
  }

  // Fetches Shopify's pagination page N and returns the rendered grid cards
  function fetchAdditionalPage(pageNumber) {
    var params = new URLSearchParams(window.location.search);
    params.set('page', String(pageNumber));
    params.delete('per_page');
    params.set('section_id', SECTION_ID);
    var url = window.location.pathname + '?' + params.toString();
    return fetch(url).then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function(html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newGrid = temp.querySelector('[data-collection-grid]');
      if (!newGrid) return [];
      return Array.from(newGrid.querySelectorAll('[data-grid-item]'));
    });
  }

  function appendExtraPages() {
    var desired = getRequestedPerPage();
    var serverSize = getServerPageSize();
    if (desired <= serverSize) return Promise.resolve();

    var currentGrid = document.querySelector('[data-collection-grid]');
    if (!currentGrid) return Promise.resolve();

    var pagesNeeded = Math.ceil(desired / serverSize) - 1;
    var currentPaginationPage = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);

    var fetches = [];
    for (var i = 1; i <= pagesNeeded; i++) {
      fetches.push(fetchAdditionalPage(currentPaginationPage + i));
    }

    return Promise.all(fetches).then(function(results) {
      // Collect existing product IDs to prevent duplicates
      var seenIds = {};
      Array.from(currentGrid.querySelectorAll('[data-product-card]')).forEach(function(el) {
        var id = el.dataset.productId;
        if (id) seenIds[id] = true;
      });

      var needed = desired - (currentGrid.querySelectorAll('[data-grid-item]').length);
      results.forEach(function(items) {
        items.forEach(function(el) {
          if (needed <= 0) return;
          var card = el.querySelector('[data-product-card]');
          var id = card && card.dataset.productId;
          if (id && seenIds[id]) return;
          if (id) seenIds[id] = true;
          currentGrid.appendChild(el);
          needed--;
        });
      });

      rewritePaginationForPerPage(desired, serverSize);

      if (typeof trackImpressions === 'function') trackImpressions();
      if (typeof trackProductClicks === 'function') trackProductClicks();
      if (window._swat && typeof window._swat.initializeActionButtonsOnProductGrid === 'function') {
        window._swat.initializeActionButtonsOnProductGrid();
      }
    }).catch(function(e) {
      // Silent failure
    });
  }

  // Fully rewrite pagination using virtual pages when per_page > default.
  // Each virtual page spans `multiplier` Shopify pages.
  function rewritePaginationForPerPage(desired, serverSize) {
    var multiplier = Math.ceil(desired / serverSize);
    if (multiplier <= 1) return;

    var paginationWrap = document.querySelector('[data-collection-pagination-wrap]');
    if (!paginationWrap) return;
    var nav = paginationWrap.querySelector('nav');
    if (!nav) return;

    var totalShopifyPages = parseInt(paginationWrap.getAttribute('data-total-pages') || '0', 10);
    if (totalShopifyPages < 1) return;
    var totalVirtualPages = Math.ceil(totalShopifyPages / multiplier);
    if (totalVirtualPages <= 1) {
      nav.style.display = 'none';
      return;
    }

    var currentShopifyPage = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    var currentVirtualPage = Math.max(1, Math.floor((currentShopifyPage - 1) / multiplier) + 1);

    // Preserve CSS classes from existing markup so styling is consistent
    var existingLink = nav.querySelector('a');
    var linkClass = existingLink ? existingLink.className : '';
    var existingSpan = nav.querySelector('span');
    var spanClass = existingSpan ? existingSpan.className : '';

    function urlForVirtual(vp) {
      var params = new URLSearchParams(window.location.search);
      var targetShopifyPage = Math.min((vp - 1) * multiplier + 1, totalShopifyPages);
      if (targetShopifyPage <= 1) {
        params.delete('page');
      } else {
        params.set('page', String(targetShopifyPage));
      }
      params.set('per_page', String(desired));
      return window.location.pathname + '?' + params.toString();
    }

    // Build page list with first, last, and window around current
    var pagesToShow = [1];
    if (currentVirtualPage - 2 > 1) pagesToShow.push('...');
    for (var i = Math.max(2, currentVirtualPage - 1); i <= Math.min(totalVirtualPages - 1, currentVirtualPage + 1); i++) {
      pagesToShow.push(i);
    }
    if (currentVirtualPage + 2 < totalVirtualPages) pagesToShow.push('...');
    if (totalVirtualPages > 1) pagesToShow.push(totalVirtualPages);
    var seen = {};
    pagesToShow = pagesToShow.filter(function(p) {
      if (p === '...') return true;
      if (seen[p]) return false;
      seen[p] = true;
      return true;
    });

    var parts = [];
    if (currentVirtualPage > 1) {
      parts.push('<a href="' + urlForVirtual(currentVirtualPage - 1) + '" class="' + linkClass + '"><span class="hidden md:inline-block">PREVIOUS</span><span class="md:hidden">Prev</span></a>');
    }
    pagesToShow.forEach(function(p) {
      if (p === '...') {
        parts.push('<span class="' + spanClass + '">&hellip;</span>');
      } else if (p === currentVirtualPage) {
        parts.push('<span class="' + spanClass + '">' + p + '</span>');
      } else {
        parts.push('<a href="' + urlForVirtual(p) + '" class="' + linkClass + '">' + p + '</a>');
      }
    });
    if (currentVirtualPage < totalVirtualPages) {
      parts.push('<a href="' + urlForVirtual(currentVirtualPage + 1) + '" class="' + linkClass + '">NEXT</a>');
    }

    nav.innerHTML = parts.join('');
  }

  // --- Pagination (SPA: prefetch on intent + lightweight grid swap) ---
  //
  // Pagination only changes the product grid + the pagination nav; the filters,
  // sort, per-page and total count are unaffected. So we swap just those two
  // regions instead of re-rendering the whole section + running the full reinit()
  // + appendExtraPages() fan-out that made the old AJAX pagination slow. The next
  // page is prefetched on hover/focus so the click is effectively instant. Any
  // failure falls back to a normal full-page navigation.

  var paginationPrefetch = {};

  function buildPaginationSectionUrl(url) {
    var u = new URL(url, window.location.origin);
    if (u.searchParams.getAll('filter.v.availability').indexOf('1') === -1) {
      u.searchParams.append('filter.v.availability', '1');
    }
    u.searchParams.set('section_id', SECTION_ID);
    return u.toString();
  }

  function prefetchPaginationPage(url) {
    var key = buildPaginationSectionUrl(url);
    if (paginationPrefetch[key]) return paginationPrefetch[key];
    var p = fetch(key).then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).catch(function() { delete paginationPrefetch[key]; return null; });
    paginationPrefetch[key] = p;
    return p;
  }

  function paginateTo(url) {
    var sectionEl = document.querySelector('[data-collection-section]');
    if (!sectionEl) { window.location.href = url; return; }

    var gridWrap = sectionEl.querySelector('[data-collection-grid-wrap]');
    if (gridWrap) {
      gridWrap.classList.add('opacity-50');
      gridWrap.style.pointerEvents = 'none';
    }

    var key = buildPaginationSectionUrl(url);
    (paginationPrefetch[key] || prefetchPaginationPage(url)).then(function(html) {
      if (!html) throw new Error('empty response');
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newSection = temp.querySelector('[data-collection-section]');
      if (!newSection) throw new Error('section not found');

      // Grid + pagination nav only — leave filters / sort / per-page untouched.
      swapRegion('[data-collection-grid-wrap]', sectionEl, newSection);
      swapRegion('[data-collection-pagination-wrap]', sectionEl, newSection);

      var cleanUrl = new URL(url, window.location.origin);
      cleanUrl.searchParams.delete('section_id');
      window.history.pushState({}, '', cleanUrl.toString());

      // Re-apply the saved view mode to the fresh grid (toolbar buttons untouched).
      var newGrid = document.querySelector('[data-collection-grid]');
      if (newGrid) {
        newGrid.setAttribute('data-view-mode', sessionStorage.getItem('collection-view-mode') || 'outfit');
      }

      // Fill virtual pages when per_page > server page size (no-op otherwise).
      appendExtraPages();

      // Re-bind grid-dependent integrations on the new cards.
      updateAllWishlistIcons();
      fetchWishlist();
      if (typeof trackImpressions === 'function') trackImpressions();
      if (typeof trackProductClicks === 'function') trackProductClicks();
      var swat = window._swat;
      if (swat && typeof swat.initializeActionButtonsOnProductGrid === 'function') {
        swat.initializeActionButtonsOnProductGrid();
      }

      // Scroll to the top of the grid, offset for the sticky header.
      var header = document.querySelector('[data-section-type="header"]') || document.querySelector('header');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = sectionEl.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }).catch(function() {
      window.location.href = url;
    }).finally(function() {
      delete paginationPrefetch[key];
      if (gridWrap) {
        gridWrap.classList.remove('opacity-50');
        gridWrap.style.pointerEvents = '';
      }
    });
  }

  function initPagination() {
    var paginationWrap = document.querySelector('[data-collection-pagination-wrap]');
    // The wrap element persists across swaps (only its innerHTML changes), so the
    // delegated listeners survive — bind them once.
    if (!paginationWrap || paginationWrap._spaPaginationBound) return;
    paginationWrap._spaPaginationBound = true;

    paginationWrap.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link || !link.closest('nav[aria-label]')) return;
      var url = link.getAttribute('href');
      if (!url) return;
      e.preventDefault();
      paginateTo(url);
    });

    // Prefetch on hover/focus so the click lands on already-fetched HTML.
    function onIntent(e) {
      var link = e.target.closest('a[href]');
      if (!link || !link.closest('nav[aria-label]')) return;
      var url = link.getAttribute('href');
      if (url) prefetchPaginationPage(url);
    }
    paginationWrap.addEventListener('mouseover', onIntent);
    paginationWrap.addEventListener('focusin', onIntent);
  }

  // --- Active filter pill links ---

  function initActiveFilterLinks() {
    // Intercept "Clear all" and individual active filter pill removal links
    var filterContainers = document.querySelectorAll('[data-active-filters]');
    filterContainers.forEach(function(container) {
      container.addEventListener('click', function(e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        e.preventDefault();
        var url = link.getAttribute('href');
        if (url) fetchAndSwap(url);
      });
    });

    // Also intercept the "Clear all" link inside mobile filter form footer and fixed bottom bar
    var clearLinks = document.querySelectorAll('[data-collection-filter-form] a[href], [data-filters-buttons] a[href]');
    clearLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var url = link.getAttribute('href');
        if (url) fetchAndSwap(url);
      });
    });
  }

  // --- View Mode Toggle ---

  function initViewToggle() {
    var buttons = document.querySelectorAll('[data-view-mode]');
    var gridEl = document.querySelector('[data-collection-grid]');
    if (!gridEl || buttons.length === 0) return;

    var savedMode = sessionStorage.getItem('collection-view-mode') || 'outfit';
    applyViewMode(savedMode, buttons, gridEl);

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var mode = btn.dataset.viewMode || 'product';
        sessionStorage.setItem('collection-view-mode', mode);
        applyViewMode(mode, buttons, gridEl);
      });
    });
  }

  function applyViewMode(mode, buttons, gridEl) {
    gridEl.setAttribute('data-view-mode', mode);

    buttons.forEach(function(btn) {
      var isActive = btn.dataset.viewMode === mode;
      if (isActive) {
        btn.classList.remove('text-tertiary', 'hover:text-primary');
        btn.classList.add('text-brand');
      } else {
        btn.classList.remove('text-brand');
        btn.classList.add('text-tertiary', 'hover:text-primary');
      }
    });
  }

  // --- Re-init after AJAX swap ---

  function reinit() {
    initFilterDrawer();
    initFilterForm();
    initSort();
    initPerPage();
    initPagination();
    initActiveFilterLinks();
    initViewToggle();
    appendExtraPages();

    // Re-init collection module (wishlist icons, GTM tracking)
    updateAllWishlistIcons();
    fetchWishlist();
    trackImpressions();
    trackProductClicks();

    // Re-attach SWYM wishlist buttons on new DOM elements
    var swat = window._swat;
    if (swat) {
      if (typeof swat.initializeActionButtons === 'function') {
        swat.initializeActionButtons();
      }
      if (typeof swat.initializeActionButtonsOnProductGrid === 'function') {
        swat.initializeActionButtonsOnProductGrid();
      }
    }
  }

  // --- Browser back/forward ---

  window.addEventListener('popstate', function() {
    fetchAndSwap(window.location.href);
  });

  // --- Filters Init ---

  function filtersInit() {
    initFilterDrawer();
    initFilterForm();
    initSort();
    initPerPage();
    initPagination();
    initActiveFilterLinks();
    initViewToggle();
  }

  // --- Combined Init ---

  // Enforce in-stock filter on initial load if missing from URL.
  // Preserves inline banners from the initial render through the swap.
  function enforceInitialAvailability() {
    var current = new URLSearchParams(window.location.search);
    var availVals = current.getAll('filter.v.availability');
    if (availVals.indexOf('1') !== -1) return;

    var grid = document.querySelector('[data-collection-grid]');
    var savedBanners = [];
    if (grid) {
      var items = Array.from(grid.children);
      items.forEach(function(child, index) {
        if (child.hasAttribute('data-inline-banner')) {
          savedBanners.push({ el: child.cloneNode(true), index: index });
        }
      });
    }

    current.append('filter.v.availability', '1');
    var url = window.location.pathname + '?' + current.toString();
    fetchAndSwap(url).then(function() {
      if (savedBanners.length === 0) return;
      var newGrid = document.querySelector('[data-collection-grid]');
      if (!newGrid) return;
      if (newGrid.querySelector('[data-inline-banner]')) return;

      var children = Array.from(newGrid.children);
      savedBanners.forEach(function(saved) {
        if (saved.index < children.length) {
          newGrid.insertBefore(saved.el, children[saved.index]);
          children = Array.from(newGrid.children);
        } else {
          newGrid.appendChild(saved.el);
        }
      });
    });
  }

  function init() {
    collectionInit();

    if (window.Shopify && Shopify.designMode) return;

    filtersInit();
    var current = new URLSearchParams(window.location.search);
    var availVals = current.getAll('filter.v.availability');
    if (availVals.indexOf('1') === -1) {
      // fetchAndSwap will trigger reinit, which calls appendExtraPages
      enforceInitialAvailability();
    } else {
      appendExtraPages();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-giftcard"]) return;
  try {
    
  (function() {
    var copyBtn = document.getElementById('gift-card-copy');
    var codeEl = document.getElementById('gift-card-code');
    if (!copyBtn || !codeEl) return;

    var labelCopy = copyBtn.dataset.labelCopy || 'Copy';
    var labelCopied = copyBtn.dataset.labelCopied || 'Copied!';

    copyBtn.addEventListener('click', function() {
      var code = codeEl.textContent.trim();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function() {
          copyBtn.textContent = labelCopied;
          setTimeout(function() { copyBtn.textContent = labelCopy; }, 2000);
        });
      } else {
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        document.execCommand('copy');
        copyBtn.textContent = labelCopied;
        setTimeout(function() { copyBtn.textContent = labelCopy; }, 2000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-login"]) return;
  try {
    
  (function() {
    var loginForm = document.getElementById('login-form');
    var recoverForm = document.getElementById('recover-form');
    var toggleBtn = document.getElementById('login-recover-toggle');
    var cancelBtn = document.getElementById('login-recover-cancel');

    function showRecover() {
      loginForm.classList.add('hidden');
      recoverForm.classList.remove('hidden');
    }

    function showLogin() {
      recoverForm.classList.add('hidden');
      loginForm.classList.remove('hidden');
    }

    if (toggleBtn) toggleBtn.addEventListener('click', showRecover);
    if (cancelBtn) cancelBtn.addEventListener('click', showLogin);

    if (window.location.hash === '#recover') {
      showRecover();
    }

    var pwField = document.getElementById('customer_password');
    var eyeIcon = loginForm.querySelector('.login-icon-eye');
    var noeyeIcon = loginForm.querySelector('.login-icon-noeye');
    var togglePw = loginForm.querySelector('.login-toggle-password');

    if (togglePw && pwField) {
      togglePw.addEventListener('click', function() {
        var isPassword = pwField.type === 'password';
        pwField.type = isPassword ? 'text' : 'password';
        eyeIcon.classList.toggle('hidden', isPassword);
        noeyeIcon.classList.toggle('hidden', !isPassword);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page-catalogue"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function qs(sel) {
      return document.querySelector(sel);
    }

    function init() {
      const container = qs('[data-catalogue-section]');
      if (!container) return;

      initSplide();
      initIframeToggle();
    }

    function initSplide() {
      const carouselEl = qs('[data-catalogue-carousel]');
      if (!carouselEl) return;

      const splide = new Splide(carouselEl, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        arrows: false,
        pagination: true,
        speed: 1000,
        gap: '0px',
        classes: {
          pagination: 'splide__pagination catalogue-dots',
        },
        breakpoints: {
          768: { perPage: 2 },
        },
      });

      splide.mount();
    }

    function initIframeToggle() {
      const iframeWrap = qs('[data-catalogue-iframe-wrap]');
      const iframe = qs('[data-catalogue-iframe]');
      if (!iframeWrap || !iframe) return;

      function openIframe(url) {
        if (!url) return;
        iframe.src = url;
        iframeWrap.style.display = 'block';
        window.scrollTo({ top: 100, behavior: 'smooth' });
      }

      // Main CTA button
      document.querySelectorAll('[data-catalogue-open]').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          const url = el.dataset.catalogueOpen || '';
          openIframe(url);
        });
      });

      // Block item clicks
      document.querySelectorAll('[data-catalogue-item]').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          const url = el.dataset.catalogueItem || '';
          openIframe(url);
        });
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page-contact"]) return;
  try {
    
(function() {
  var form = document.getElementById('contact-form');
  if (!form) return;

  var formWrap = document.getElementById('contact-form-wrap');
  var successEl = document.getElementById('contact-success');
  var loadingEl = document.getElementById('contact-loading');
  var errorEl = document.getElementById('contact-error');
  var submitBtn = form.querySelector('button[type="submit"]');
  var zendeskUrl = 'https://gazmancustomersupport.zendesk.com/api/v2/requests.json';

  var fields = {
    name: form.querySelector('#contact_name'),
    email: form.querySelector('#contact_email'),
    subject: form.querySelector('#contact_subject'),
    message: form.querySelector('#contact_message')
  };

  function setFieldError(el, hasError) {
    if (!el) return;
    if (hasError) {
      el.classList.remove('border-grey');
      el.classList.add('border-red');
    } else {
      el.classList.remove('border-red');
      el.classList.add('border-grey');
    }
  }

  function clearFieldError(el) {
    setFieldError(el, false);
  }

  /* Clear error on focus */
  Object.keys(fields).forEach(function(key) {
    if (fields[key]) {
      fields[key].addEventListener('focus', function() {
        clearFieldError(this);
        /* Also clear the select wrapper border if focusing subject */
        if (key === 'subject') {
          var wrap = document.getElementById('contact-subject-wrap');
          if (wrap) clearFieldError(wrap);
        }
        if (errorEl) errorEl.style.display = 'none';
      });
    }
  });

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var name = fields.name.value.trim();
    var email = fields.email.value.trim();
    var subject = fields.subject.value;
    var message = fields.message.value.trim();

    /* Validate required fields */
    var hasErrors = false;

    if (!name) { setFieldError(fields.name, true); hasErrors = true; }
    if (!email) { setFieldError(fields.email, true); hasErrors = true; }
    var subjectWrap = document.getElementById('contact-subject-wrap');
    if (!subject) { setFieldError(subjectWrap, true); hasErrors = true; }
    if (!message) { setFieldError(fields.message, true); hasErrors = true; }

    if (hasErrors) {
      if (errorEl) {
        errorEl.textContent = form.dataset.errorRequired || 'Please fill out all required fields.';
        errorEl.style.display = 'block';
      }
      return;
    }

    if (errorEl) errorEl.style.display = 'none';
    loadingEl.style.display = 'block';
    submitBtn.disabled = true;

    var ticketObject = {
      request: {
        requester: { name: name, email: email },
        status: 'new',
        subject: subject,
        comment: { body: message }
      }
    };

    fetch(zendeskUrl, {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify(ticketObject)
    }).then(function() {
      loadingEl.style.display = 'none';
      formWrap.style.display = 'none';
      successEl.style.display = 'block';
    }).catch(function() {
      loadingEl.style.display = 'none';
      submitBtn.disabled = false;
      if (errorEl) {
        errorEl.textContent = form.dataset.errorServer || 'Sorry, something went wrong. Please try again.';
        errorEl.style.display = 'block';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page-size-guide"]) return;
  try {
    
  (function() {
    var source = document.getElementById('size-guide-page-data');
    var target = document.getElementById('size-guide-target');
    if (source && target) {
      source.classList.remove('hidden');
      target.appendChild(source);
    }

    // Insert body diagram image from theme-size-guide-images JSON
    var diagramEl = document.getElementById('size-guide-page-diagram');
    var jsonEl = document.getElementById('size-guide-images-json');
    if (diagramEl && jsonEl) {
      try {
        var data = JSON.parse(jsonEl.textContent);
        var imgUrl = data.master_image || data.top_image;
        if (imgUrl) {
          var img = document.createElement('img');
          img.src = imgUrl;
          img.alt = 'Body measurement diagram';
          img.loading = 'lazy';
          img.style.maxWidth = '100%';
          img.style.maxHeight = '500px';
          img.style.height = 'auto';
          img.style.width = 'auto';
          img.style.margin = '0 auto';
          img.style.display = 'block';
          diagramEl.appendChild(img);
        }
      } catch(e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page-stores"]) return;
  try {
    
(function() {
  /**
   * Store Locator module
   * Google Maps, Places Autocomplete search, state filtering, distance sorting,
   * single-store mode with Splide gallery, and URL ?q= param handling.
   */

  // --- Constants ---

  const STATE_BOUNDS = [
    { name: 'ACT', longName: 'Australian Capital Territory', nw: { lat: -35.1, lng: 148.72 }, se: { lat: -35.96, lng: 149.45 } },
    { name: 'NSW', longName: 'New South Wales', nw: { lat: -27.9, lng: 140.6 }, se: { lat: -37.8, lng: 153.9 } },
    { name: 'NT', longName: 'Northern Territory', nw: { lat: -10.6, lng: 127.5 }, se: { lat: -26.5, lng: 139.5 } },
    { name: 'QLD', longName: 'Queensland', nw: { lat: -9, lng: 137.6 }, se: { lat: -29.5, lng: 154 } },
    { name: 'SA', longName: 'South Australia', nw: { lat: -25.6, lng: 128.5 }, se: { lat: -38.5, lng: 141.5 } },
    { name: 'TAS', longName: 'Tasmania', nw: { lat: -39, lng: 143.5 }, se: { lat: -44, lng: 149 } },
    { name: 'VIC', longName: 'Victoria', nw: { lat: -33.8, lng: 140.6 }, se: { lat: -39.3, lng: 150.3 } },
    { name: 'WA', longName: 'Western Australia', nw: { lat: -13.2, lng: 112.5 }, se: { lat: -35.5, lng: 129.5 } },
  ];

  const POSTCODES_BY_STATE = [
    { min: 1000, max: 2600, name: 'NSW' },
    { min: 2619, max: 2899, name: 'NSW' },
    { min: 2921, max: 2999, name: 'NSW' },
    { min: 200, max: 299, name: 'ACT' },
    { min: 2600, max: 2618, name: 'ACT' },
    { min: 2900, max: 2920, name: 'ACT' },
    { min: 3000, max: 3999, name: 'VIC' },
    { min: 8000, max: 8999, name: 'VIC' },
    { min: 4000, max: 4999, name: 'QLD' },
    { min: 9000, max: 9999, name: 'QLD' },
    { min: 5000, max: 5999, name: 'SA' },
    { min: 6000, max: 7000, name: 'WA' },
    { min: 7000, max: 7999, name: 'TAS' },
    { min: 800, max: 899, name: 'NT' },
  ];

  const BRAND_COLOR = '#002144';

  // --- Helpers ---

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function haversineDistance(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLon = ((lon2 - lon1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function appendPostcode(value) {
    if (/^\d+$/.test(value)) {
      const postcode = parseInt(value, 10);
      const match = POSTCODES_BY_STATE.find(function(r) { return r.min <= postcode && postcode <= r.max; });
      if (match) return value + ', ' + match.name;
    }
    return value;
  }

  function isStoreOpen(store) {
    if (store.storenotes && store.storenotes.toLowerCase().includes('closed')) return false;
    return true;
  }

  // --- State ---

  let container = null;
  let stores = [];
  let map = null;
  let markers = [];
  let searchCircle = null;
  let searchCenter = null;
  let searchRadius = 100;
  let activeState = null;
  let clickedStore = null;
  let isSingleStore = false;
  let focusStoreId = null;
  let infoWindow = null;
  let markerIconUrl = null;

  // --- Store Data ---

  function loadStores() {
    const el = document.getElementById('stores-data-json');
    if (!el) return;
    try {
      stores = JSON.parse(el.textContent || '[]').filter(
        function(s) { return s.lat && s.long; }
      );
    } catch (e) {
      stores = [];
    }
  }

  // --- Map Pin ---

  function getMarkerIcon() {
    if (markerIconUrl) {
      return {
        url: markerIconUrl,
        scaledSize: new google.maps.Size(24, 37),
        anchor: new google.maps.Point(12, 37),
      };
    }
    // Fallback to inline SVG with brand color
    const svg = '<svg width="24" height="37" viewBox="0 0 101 159" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="none"><path d="M50.387 0C22.772 0 .39 22.385.39 50c0 27.612 49.997 108.716 49.997 108.716S100.39 77.612 100.39 50c0-27.618-22.38-50-50.003-50z" fill="' + BRAND_COLOR + '"/><path d="M26 50.4c.22-.288.212-.638.236-.976a27.99 27.99 0 011.226-6.53c1.214-3.854 3.248-7.208 6.004-10.12 1.994-2.114 4.226-3.914 6.786-5.274a21.04 21.04 0 017.304-2.32c2.98-.376 5.92-.18 8.795.752 2.308.746 4.404 1.906 6.326 3.396.168.13.336.26.506.384.032.02.08.02.16.04.144-.15.312-.312.464-.486.76-.86 1.524-1.712 2.262-2.588.228-.268.458-.396.808-.378.504.028 1.01.006 1.514.01.144 0 .288.018.464.03.02.14.048.26.056.38.008.15.002.3.002.45v13.91c0 .252-.01.506-.014.744-.46.124-1.74.146-2.514.048-.068-.2-.15-.416-.218-.638-.42-1.366-.936-2.7-1.544-3.992a20.938 20.938 0 00-2.646-4.276c-2.184-2.686-4.934-4.424-8.311-5.08-2.212-.43-4.432-.476-6.638.072-1.306.326-2.494.9-3.494 1.832-1.07 1-1.722 2.25-2.12 3.652-.296 1.03-.426 2.09-.514 3.156-.294 3.622-.368 7.256-.37 10.888-.004 4.915.012 9.831.032 14.745.006 1.56.04 3.12.09 4.68.04 1.306.24 2.59.61 3.848.816 2.76 2.656 4.374 5.378 5.024 1.05.252 2.12.328 3.194.32 1.01-.008 2.02-.066 3.008-.312.91-.226 1.752-.59 2.458-1.24.947-.872 1.48-1.964 1.62-3.24.12-1.104.233-2.212.255-3.32.046-2.458.032-4.916.042-7.374 0-.146-.016-.292-.024-.452-.238-.12-.472-.08-.696-.08-1.83-.004-3.66 0-5.491-.006-.224 0-.462.056-.67-.08-.076-.484-.086-1.696-.02-2.4.106-.024.22-.066.34-.076.166-.016.336-.006.504-.006l21.967.002c.27 0 .546-.05.806.062.086.502.09 1.876.006 2.44-.428.12-.872.046-1.308.06-.42.012-.842 0-1.262 0l-1.284.016c-.194.196-.136.4-.136.582-.006 1.624-.004 3.248-.004 4.872v4.708c-.07.086-.104.14-.15.182-2.56 2.414-5.364 4.47-8.534 5.986a25.76 25.76 0 01-7.587 2.284c-.436.06-.878.1-1.316.16-.12.018-.23.082-.346.126h-3.284c-.16-.046-.32-.108-.482-.132-.56-.084-1.126-.148-1.688-.23-3.43-.51-6.576-1.764-9.376-3.84-4.646-3.44-7.864-7.956-9.662-13.502a28.076 28.076 0 01-1.288-6.9c-.02-.32-.022-.646-.232-.916V50.4z" fill="#FFF"/></g></svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(24, 37),
      anchor: new google.maps.Point(12, 37),
    };
  }

  // --- Google Map ---

  function initMap() {
    if (!container) return;
    const mapEl = qs('[data-store-map]', container);
    if (!mapEl || typeof google === 'undefined' || !google.maps) return;

    const stylingAttr = container.dataset.mapStyling;
    let mapStyles = [];
    if (stylingAttr) {
      try {
        mapStyles = JSON.parse(stylingAttr);
      } catch (e) { /* ignore */ }
    }

    let center;
    let zoom;

    if (isSingleStore && focusStoreId) {
      const store = stores.find(function(s) { return s.id === focusStoreId; });
      if (store) {
        center = { lat: parseFloat(store.lat), lng: parseFloat(store.long) };
        zoom = 14;
      } else {
        center = { lat: -25.2744, lng: 133.7751 };
        zoom = 4;
      }
    } else {
      center = { lat: -25.2744, lng: 133.7751 };
      zoom = window.innerWidth < 768 ? 3.25 : 4.25;
    }

    map = new google.maps.Map(mapEl, {
      center: center,
      zoom: zoom,
      styles: mapStyles,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
    });

    infoWindow = new google.maps.InfoWindow();

    // Google moves focus into the info window when it opens, which surfaces the
    // theme's global focus-visible ring (a navy box around the store name) even
    // for mouse and touch users. Drop that auto-focus on open so the ring is
    // reserved for genuine keyboard navigation into the tooltip links.
    infoWindow.addListener('domready', function() {
      var active = document.activeElement;
      if (active && typeof active.closest === 'function' && active.closest('.gm-style-iw')) {
        active.blur();
      }
    });

    addMarkers();

    // URL param ?q= auto-search
    if (!isSingleStore) {
      const params = new URLSearchParams(window.location.search);
      const q = params.get('q');
      if (q) {
        const input = qs('[data-store-search-input]', container);
        if (input) input.value = q;
        handleSearch(q);
      }
    }
  }

  function addMarkers() {
    // Clear existing
    markers.forEach(function(m) { m.setMap(null); });
    markers = [];

    const storesToShow = isSingleStore && focusStoreId
      ? stores.filter(function(s) { return s.id === focusStoreId; })
      : stores;

    storesToShow.forEach(function(store) {
      const lat = parseFloat(store.lat);
      const lng = parseFloat(store.long);
      if (isNaN(lat) || isNaN(lng)) return;

      const marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        title: store.title,
        icon: getMarkerIcon(),
      });

      marker.addListener('click', function() {
        handleStoreClick(store, true);
      });

      marker.__storeData = store;
      markers.push(marker);
    });
  }

  function stateMatches(stateValue) {
    if (!activeState) return false;
    const s = (stateValue || '').trim().toUpperCase();
    return s === activeState.name || s === activeState.longName.toUpperCase();
  }

  function isWithinRange(store) {
    if (activeState) {
      return stateMatches(store.state);
    }
    if (searchCenter) {
      const dist = haversineDistance(
        parseFloat(store.lat), parseFloat(store.long),
        searchCenter.lat, searchCenter.lng
      );
      return dist < searchRadius;
    }
    return true;
  }

  function showTooltip(store, marker) {
    if (!infoWindow) return;

    const content = '<div style="padding:16px;min-width:256px;box-sizing:border-box;font-family:inherit;">' +
      (!isSingleStore && store.link
        ? '<a href="' + store.link + '" style="font-weight:600;font-size:14px;text-decoration:underline;">' + store.title + '</a>'
        : '<strong style="font-size:14px;">' + store.title + '</strong>'
      ) +
      '<div style="margin-top:6px;font-size:11px;color:#333;">' + store.address + '<br>' + store.suburb + '<br>' + store.state + ', ' + store.postcode + '</div>' +
      '<div style="margin-top:6px;">' +
      (isSingleStore
        ? '<a href="https://www.google.com/maps?saddr=My+Location&daddr=' + encodeURIComponent(store.address + ' ' + store.suburb + ' ' + store.state + ' ' + store.postcode) + '" target="_blank" rel="noreferrer" style="font-size:12px;text-decoration:underline;">Get Directions</a>'
        : (store.link ? '<a href="' + store.link + '" style="font-size:12px;text-decoration:underline;">Store Details</a>' : '')
      ) +
      '</div></div>';

    infoWindow.setContent(content);
    infoWindow.open(map, marker);
  }

  // --- Store Click ---

  function handleStoreClick(store, fromMap) {
    clickedStore = store;
    activeState = null;

    const lat = parseFloat(store.lat);
    const lng = parseFloat(store.long);

    map.setCenter({ lat: lat, lng: lng });
    map.setZoom(14);

    // Clear circle
    if (searchCircle) {
      searchCircle.setMap(null);
      searchCircle = null;
    }
    searchCenter = null;

    // Show tooltip
    const marker = markers.find(function(m) { return m.__storeData && m.__storeData.id === store.id; });
    if (marker) showTooltip(store, marker);

    // Highlight in list
    if (!isSingleStore) {
      highlightListItem(store);
      if (!fromMap) return;
      // Scroll list to this store
      const handle = store.title.toLowerCase().replace(/\s+/g, '-');
      const target = document.getElementById(handle);
      if (target && target.parentElement) {
        target.parentElement.scrollTop = target.offsetTop - target.offsetHeight * 1.25;
      }
    }
  }

  function highlightListItem(store) {
    if (!container) return;
    qsa('[data-store-item]', container).forEach(function(el) {
      if (el.dataset.storeItem === store.id) {
        el.classList.add('bg-brand-highlight');
        el.classList.remove('hover:bg-grey-lightest');
      } else {
        el.classList.remove('bg-brand-highlight');
        el.classList.add('hover:bg-grey-lightest');
      }
    });
  }

  // --- Search ---

  function handleSearch(value) {
    if (typeof google === 'undefined' || !google.maps) return;

    const geocoder = new google.maps.Geocoder();
    const valueWithPostcode = appendPostcode(value);
    const address = valueWithPostcode + (!value.includes('Australia') ? ' Australia' : '');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== 'OK' || !(results && results[0])) return;

      const loc = results[0].geometry.location;
      const lat = loc.lat();
      const lng = loc.lng();

      searchCenter = { lat: lat, lng: lng };
      clickedStore = null;
      activeState = null;

      // Center map
      map.setCenter({ lat: lat, lng: lng });

      // Zoom to fit radius
      const zoomForRadius = getZoomForRadius(lat, lng, searchRadius);
      map.setZoom(zoomForRadius);

      // Draw circle
      if (searchCircle) searchCircle.setMap(null);
      searchCircle = new google.maps.Circle({
        strokeColor: BRAND_COLOR,
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#FF0000',
        fillOpacity: 0.1,
        map: map,
        center: { lat: lat, lng: lng },
        radius: searchRadius * 1000,
      });

      // Update marker colors
      updateMarkerColors();

      // Sort and filter list
      sortAndFilterList();
    });
  }

  function getZoomForRadius(lat, lng, radius) {
    // Approximate zoom level based on radius
    const mapEl = qs('[data-store-map]', container);
    if (!mapEl) return 10;

    const metersPerPixel = (radius * 1000 * 2) / mapEl.clientWidth;
    // Earth circumference at latitude / (256 * 2^zoom) = metersPerPixel
    const earthCircumference = 40075016.686 * Math.cos((lat * Math.PI) / 180);
    const zoom = Math.log2(earthCircumference / (metersPerPixel * 256));
    return Math.min(Math.max(Math.floor(zoom), 5), 15);
  }

  // --- State Filter ---

  function handleStateFilter(stateName) {
    const bound = STATE_BOUNDS.find(function(s) { return s.name.toLowerCase() === stateName.toLowerCase(); });
    if (!bound) return;

    // Toggle off if same state
    if (activeState && activeState.name === bound.name) {
      activeState = null;
      searchCenter = null;
      if (searchCircle) {
        searchCircle.setMap(null);
        searchCircle = null;
      }
      map.setCenter({ lat: -25.2744, lng: 133.7751 });
      map.setZoom(window.innerWidth < 768 ? 3.25 : 4.25);
      updateMarkerColors();
      resetListOrder();
      updateStateButtonStyles(null);
      return;
    }

    activeState = bound;
    clickedStore = null;
    searchCenter = null;
    if (searchCircle) {
      searchCircle.setMap(null);
      searchCircle = null;
    }

    // Fit bounds to state
    const bounds = new google.maps.LatLngBounds(
      { lat: bound.se.lat, lng: bound.nw.lng },
      { lat: bound.nw.lat, lng: bound.se.lng }
    );
    map.fitBounds(bounds);

    updateMarkerColors();
    sortAndFilterList();
    updateStateButtonStyles(bound.name);
    scrollListToTop();
  }

  function updateStateButtonStyles(activeName) {
    if (!container) return;
    qsa('[data-state-filter]', container).forEach(function(btn) {
      if (activeName && btn.dataset.stateFilter === activeName.toLowerCase()) {
        btn.classList.add('font-semibold');
      } else {
        btn.classList.remove('font-semibold');
      }
    });
  }

  // --- List Group Headers (state filter) ---

  function removeListHeaders(listWrapper) {
    qsa('[data-list-header]', listWrapper).forEach(function(el) { el.remove(); });
  }

  function createListHeader(text, zClass) {
    const el = document.createElement('div');
    el.className = 'block text-left text-lg p-1-6 bg-grey font-medium sticky pin-t pin-l ' + zClass;
    el.setAttribute('data-list-header', '');
    el.textContent = text;
    return el;
  }

  function createNoResultsMessage() {
    const el = document.createElement('div');
    el.className = 'block text-left text-base p-1-6 font-medium';
    el.setAttribute('data-list-header', '');
    el.textContent = 'No Results';
    return el;
  }

  // --- List Sorting ---

  function sortAndFilterList() {
    if (!container) return;
    const listWrapper = qs('[data-store-list]', container);
    if (!listWrapper) return;

    removeListHeaders(listWrapper);

    const items = qsa('[data-store-item]', listWrapper);
    const itemsWithData = items.map(function(el) {
      return {
        el: el,
        lat: parseFloat(el.dataset.storeLat || '0'),
        lng: parseFloat(el.dataset.storeLng || '0'),
        state: (el.dataset.storeState || '').toUpperCase(),
        title: el.dataset.storeTitle || '',
      };
    });

    if (searchCenter) {
      // Sort by distance, show distance labels
      itemsWithData.forEach(function(item) {
        const dist = haversineDistance(item.lat, item.lng, searchCenter.lat, searchCenter.lng);
        const distEl = item.el.querySelector('[data-store-distance]');
        if (distEl) {
          if (dist < searchRadius) {
            distEl.textContent = dist.toFixed(dist > 10 ? 0 : 1) + 'km';
            distEl.classList.remove('hidden');
          } else {
            distEl.classList.add('hidden');
          }
        }
        item.distance = dist;
      });

      itemsWithData.sort(function(a, b) { return a.distance - b.distance; });

      // Show in-range, hide out-of-range
      itemsWithData.forEach(function(item) {
        if (item.distance < searchRadius) {
          item.el.classList.remove('hidden');
        } else {
          item.el.classList.add('hidden');
        }
      });
    } else if (activeState) {
      // Sort: in-state first, then out-of-state, with group headers
      const inState = itemsWithData.filter(function(i) { return stateMatches(i.state); });
      const outState = itemsWithData.filter(function(i) { return !stateMatches(i.state); });

      inState.sort(function(a, b) { return a.title.localeCompare(b.title); });
      outState.sort(function(a, b) { return a.title.localeCompare(b.title); });

      const sorted = inState.concat(outState);
      itemsWithData.length = 0;
      Array.prototype.push.apply(itemsWithData, sorted);

      // Show all, clear distance labels
      itemsWithData.forEach(function(item) {
        item.el.classList.remove('hidden');
        const distEl = item.el.querySelector('[data-store-distance]');
        if (distEl) distEl.classList.add('hidden');
      });
    }

    // Re-order DOM
    itemsWithData.forEach(function(item) { listWrapper.appendChild(item.el); });

    // Insert group headers when a state filter is active (matches live theme)
    if (!searchCenter && activeState) {
      const inStateCount = itemsWithData.filter(function(i) { return stateMatches(i.state); }).length;
      const firstOut = itemsWithData.find(function(i) { return !stateMatches(i.state); });

      const thisHeader = createListHeader('In this state', 'z-0');
      if (itemsWithData.length) {
        listWrapper.insertBefore(thisHeader, itemsWithData[0].el);
      } else {
        listWrapper.appendChild(thisHeader);
      }
      if (!inStateCount) {
        thisHeader.insertAdjacentElement('afterend', createNoResultsMessage());
      }
      if (firstOut) {
        listWrapper.insertBefore(createListHeader('In other states', 'z-10'), firstOut.el);
      }
    }
  }

  function resetListOrder() {
    if (!container) return;
    const listWrapper = qs('[data-store-list]', container);
    if (!listWrapper) return;

    removeListHeaders(listWrapper);

    const items = qsa('[data-store-item]', listWrapper);
    items.forEach(function(el) {
      el.classList.remove('hidden');
      const distEl = el.querySelector('[data-store-distance]');
      if (distEl) distEl.classList.add('hidden');
    });

    // Sort alphabetically by title
    const sorted = items.slice().sort(function(a, b) {
      const titleA = a.dataset.storeTitle || '';
      const titleB = b.dataset.storeTitle || '';
      return titleA.localeCompare(titleB);
    });
    sorted.forEach(function(el) { listWrapper.appendChild(el); });
  }

  function scrollListToTop() {
    const wrapper = document.getElementById('list-items-wrapper');
    if (wrapper) wrapper.scrollTop = 0;
  }

  // --- Marker Colors ---

  function updateMarkerColors() {
    const icon = getMarkerIcon();
    markers.forEach(function(marker) {
      const store = marker.__storeData;
      if (!store) return;

      const inRange = isWithinRange(store);
      if (inRange) {
        marker.setIcon(icon);
        marker.setOpacity(1);
      } else {
        marker.setIcon(icon);
        marker.setOpacity(0.4);
      }
    });
  }

  // --- Places Autocomplete ---

  function initAutocomplete() {
    if (!container || typeof google === 'undefined' || !(google.maps && google.maps.places)) return;
    const input = qs('[data-store-search-input]', container);
    if (!input) return;

    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'au' },
      types: ['(regions)'],
    });

    autocomplete.addListener('place_changed', function() {
      const place = autocomplete.getPlace();
      if (place && place.geometry && place.geometry.location) {
        handleSearch(input.value);
      }
    });
  }

  // --- Event Bindings ---

  function bindEvents() {
    if (!container) return;

    // Search button
    const searchBtn = qs('[data-store-search-btn]', container);
    const searchInput = qs('[data-store-search-input]', container);

    if (searchBtn && searchInput) {
      searchBtn.addEventListener('click', function() {
        if (searchInput.value.trim()) handleSearch(searchInput.value.trim());
      });
    }

    // Enter key in search
    if (searchInput) {
      searchInput.addEventListener('keyup', function(e) {
        if (e.key === 'Enter' && searchInput.value.trim()) {
          handleSearch(searchInput.value.trim());
        }
      });
    }

    // State filter buttons
    qsa('[data-state-filter]', container).forEach(function(btn) {
      btn.addEventListener('click', function() {
        const stateName = btn.dataset.stateFilter || '';
        handleStateFilter(stateName);
      });
    });

    // Store list item clicks
    qsa('[data-store-item]', container).forEach(function(el) {
      el.addEventListener('click', function(e) {
        // Don't capture link clicks
        if (e.target.tagName === 'A') return;

        const storeId = el.dataset.storeItem;
        const store = stores.find(function(s) { return s.id === storeId; });
        if (store) handleStoreClick(store, false);
      });
    });
  }

  // --- Splide Gallery (single store) ---

  function initGallery() {
    if (!container) return;
    const splideEl = qs('[data-store-gallery-splide]', container);
    if (!splideEl) return;

    const slides = splideEl.querySelectorAll('.splide__slide');
    if (slides.length <= 1) return;

    new Splide(splideEl, {
      type: 'loop',
      perPage: 1,
      pagination: true,
      arrows: true,
      autoplay: false,
    }).mount();
  }

  // --- Init ---

  function init() {
    container = qs('[data-store-locator]');
    if (!container) return;

    focusStoreId = container.dataset.focusStore || null;
    isSingleStore = !!focusStoreId;
    searchRadius = parseInt(container.dataset.searchRadius || '100', 10);
    markerIconUrl = container.dataset.markerIcon || null;

    loadStores();

    // Wait for Google Maps to be ready. The Maps script is deferred, so on the
    // first pass the `google` global may not exist yet. Use typeof to avoid a
    // ReferenceError on the bare identifier, which would crash init() before it
    // could schedule the retry below.
    if (typeof google === 'undefined' || !google.maps) {
      setTimeout(init, 200);
      return;
    }

    initMap();

    if (isSingleStore) {
      initGallery();
    } else {
      initAutocomplete();
      bindEvents();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page-wishlist"]) return;
  try {
    
(function() {
  /**
   * Wishlist page module
   * Fetches SWYM wishlist data, renders product cards with qty/size selectors,
   * add-to-bag and remove functionality, and share links.
   */

  // --- Helpers ---

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function formatMoney(cents) {
    if (window.Gazman && window.Gazman.formatMoney) return window.Gazman.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function addToCart(variantId, quantity, productTags) {
    var properties = window.Gazman && window.Gazman.buildDiscountProperties
      ? window.Gazman.buildDiscountProperties(productTags || [])
      : null;
    return window.Gazman.addToCart(variantId, quantity || 1, properties || undefined);
  }

  // --- Member / sale pricing (settings populated from page data attrs in init) ---

  var discountActive = false;
  var discountTag = '';
  var discountLabel = '';
  var discountAmount = 0;

  // products/*.json returns prices as dollar strings ("79.00"); normalise to cents.
  function toCents(value) {
    if (value === null || value === undefined || value === '') return 0;
    var n = parseFloat(value);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function tagsToList(rawTags) {
    if (Array.isArray(rawTags)) {
      return rawTags.map(function(t) { return String(t).trim(); });
    }
    if (typeof rawTags === 'string') {
      return rawTags.split(',').map(function(t) { return t.trim(); });
    }
    return [];
  }

  function getPromohex(tagList) {
    var hex = '';
    tagList.forEach(function(t) {
      if (t.indexOf('promohex:') === 0) hex = t.slice(9).trim();
    });
    return hex;
  }

  // Renders flag badges (flag: tags + auto "Sale"), mirroring the collection
  // product card. Bracket icon tokens are stripped from the displayed text.
  function renderFlags(card, product, onSale) {
    var wrap = card.querySelector('[data-card-flags]');
    var list = card.querySelector('[data-card-flags-list]');
    if (!wrap || !list) return;

    var flags = [];
    tagsToList(product.tags).forEach(function(t) {
      if (t.indexOf('flag:') === 0) flags.push(t.slice(5).trim());
    });
    if (onSale) flags.push('Sale');

    list.innerHTML = '';
    if (!flags.length) { wrap.classList.add('hidden'); return; }

    flags.forEach(function(flag) {
      var lower = flag.toLowerCase();
      var colour = 'text-primary';
      if (lower.indexOf('frenzy') !== -1) colour = 'text-clickfrenzy';
      else if (lower.indexOf('sale') !== -1) colour = 'text-red';

      var outer = document.createElement('span');
      outer.className = 'badges flex items-center justify-start ie-product-flag ' + colour;
      var inner = document.createElement('span');
      inner.className = 'text-xs leading-looser font-semibold uppercase';
      inner.textContent = flag.replace(/\[(multi|percent|stopwatch|tag|timer)\]/g, '').trim();
      outer.appendChild(inner);
      list.appendChild(outer);
    });
    wrap.classList.remove('hidden');
  }

  // Renders regular/sale/member pricing for a card using the selected variant,
  // mirroring the live collection product card rules.
  function renderPrice(card, product, variant) {
    var priceEl = card.querySelector('[data-card-price]');
    var compareWrap = card.querySelector('[data-card-compare-wrap]');
    var compareEl = card.querySelector('[data-card-compare-price]');
    var memberRow = card.querySelector('[data-card-member-row]');
    var memberLabelEl = card.querySelector('[data-card-member-label]');
    var memberPriceEl = card.querySelector('[data-card-member-price]');

    var priceCents = toCents(variant.price);
    var compareCents = toCents(variant.compare_at_price);
    var onSale = compareCents > priceCents;

    renderFlags(card, product, onSale);

    if (priceEl) {
      priceEl.textContent = priceCents ? formatMoney(priceCents) : '';
      priceEl.classList.remove('text-primary', 'text-red', 'font-medium');
      priceEl.classList.add(onSale ? 'text-red' : 'text-primary');
      if (onSale) priceEl.classList.add('font-medium');
    }

    if (compareWrap && compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(compareCents);
        compareWrap.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareWrap.classList.add('hidden');
      }
    }

    var showMember = false;
    if (discountActive && discountTag && discountAmount > 0) {
      var tagList = tagsToList(product.tags);
      if (tagList.indexOf(discountTag) !== -1) {
        var memberCents = Math.round(priceCents * (100 - discountAmount) / 100);
        if (memberCents < priceCents) {
          showMember = true;
          if (memberLabelEl) {
            memberLabelEl.textContent = discountLabel;
            memberLabelEl.style.color = getPromohex(tagList) || '';
          }
          if (memberPriceEl) memberPriceEl.textContent = formatMoney(memberCents);
          if (memberRow) memberRow.classList.remove('hidden');
        }
      }
    }
    if (!showMember && memberRow) {
      memberRow.classList.add('hidden');
      if (memberLabelEl) memberLabelEl.textContent = '';
      if (memberPriceEl) memberPriceEl.textContent = '';
    }
  }

  // --- Fetch full product data ---

  function fetchProductByUrl(du) {
    try {
      var url = new URL(du);
      return fetch(url.pathname + '.json')
        .then(function(res) { return res.json(); })
        .then(function(data) { return data.product || null; })
        .catch(function() { return null; });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  // --- Card Rendering (template-based) ---

  function populateQtySelect(sel, inventory, available) {
    var previousValue = sel.value || '1';
    var inventoryCount = parseInt(inventory, 10);
    if (isNaN(inventoryCount)) inventoryCount = 0;

    sel.innerHTML = '';
    if (!available) {
      sel.disabled = true;
      return;
    }

    sel.disabled = false;
    var cap = inventoryCount > 0 ? Math.min(inventoryCount, 10) : 10;
    for (var i = 1; i <= cap; i++) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = String(i);
      sel.appendChild(opt);
    }

    if (parseInt(previousValue, 10) <= cap) {
      sel.value = previousValue;
    } else {
      sel.value = '1';
    }
  }

  function populateSizeSelect(sel, variants) {
    sel.innerHTML = '';
    variants.forEach(function(v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.dataset.inventory = String(v.inventory_quantity);
      opt.dataset.available = String(v.available !== false);
      opt.textContent = v.title;
      sel.appendChild(opt);
    });
  }

  function renderCard(item, index) {
    var product = item.fullProduct;
    if (!product) return null;

    var variant = (product.variants && product.variants.find(function(v) { return v.id === item.epi; })) || (product.variants && product.variants[0]);
    if (!variant) return null;

    var tmpl = document.getElementById('wishlist-card-template');
    if (!tmpl) return null;

    var card = tmpl.content.cloneNode(true).firstElementChild;

    var imageUrl = item.iu || (product.images && product.images[0] && product.images[0].src ? product.images[0].src : '');
    var productUrl = item.du ? new URL(item.du).pathname : '/products/' + product.handle;
    var available = variant.available !== false;
    var inventory = variant.inventory_quantity || 0;
    var variants = product.variants || [];

    // Data attributes
    card.dataset.empi = String(item.empi);
    card.dataset.epi = String(item.epi);

    // Image + links
    var imgLink = card.querySelector('[data-card-link]');
    var titleLink = card.querySelector('[data-card-title-link]');
    var img = card.querySelector('[data-card-image]');
    if (imgLink) { imgLink.href = productUrl; imgLink.title = product.title; }
    if (titleLink) { titleLink.href = productUrl; titleLink.title = product.title; }
    if (img && imageUrl) { img.src = imageUrl; img.alt = product.title; }
    else if (img) { img.parentNode.removeChild(img); }

    // Title + price
    var titleEl = card.querySelector('[data-card-title]');
    if (titleEl) titleEl.textContent = product.title;

    renderPrice(card, product, variant);

    // Qty + Size selects
    var qtySel = card.querySelector('[data-wishlist-qty]');
    var sizeSel = card.querySelector('[data-wishlist-size]');
    if (qtySel) {
      qtySel.dataset.wishlistQty = String(index);
      populateQtySelect(qtySel, inventory, available);
    }
    if (sizeSel) {
      sizeSel.dataset.wishlistSize = String(index);
      sizeSel.dataset.currentVariantId = String(variant.id);
      populateSizeSelect(sizeSel, variants);
      sizeSel.value = String(variant.id);
    }

    // Add to bag button
    var addBtn = card.querySelector('[data-wishlist-add]');
    if (addBtn) {
      addBtn.dataset.wishlistAdd = String(index);
      addBtn.dataset.productTags = JSON.stringify(product.tags || []);
      if (available) {
        addBtn.dataset.variantId = String(variant.id);
        addBtn.classList.add('bg-primary', 'text-light', 'hover:bg-secondary');
      } else {
        addBtn.disabled = true;
        addBtn.textContent = wishlistLabels.outOfStock;
        addBtn.classList.add('bg-grey', 'text-dark-grey', 'cursor-not-allowed');
      }
    }

    // Remove button
    var removeBtn = card.querySelector('[data-wishlist-remove]');
    if (removeBtn) {
      removeBtn.dataset.wishlistRemove = String(index);
      removeBtn.dataset.empi = String(item.empi);
      removeBtn.dataset.epi = String(item.epi);
      removeBtn.dataset.du = item.du || '';
    }

    return card;
  }

  // --- Main Logic ---

  var products = [];
  var shareLink = null;

  function render() {
    var container = qs('[data-wishlist-items]');
    var loading = qs('[data-wishlist-loading]');
    var empty = qs('[data-wishlist-empty]');

    if (loading) loading.classList.add('hidden');

    if (!container) return;

    if (products.length === 0) {
      container.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      return;
    }

    if (empty) empty.classList.add('hidden');
    container.innerHTML = '';
    products.forEach(function(p, i) {
      var card = renderCard(p, i);
      if (card) container.appendChild(card);
    });
    bindCardEvents();
  }

  function bindCardEvents() {
    // Size change -> update qty options + variant
    document.querySelectorAll('[data-wishlist-size]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var idx = parseInt(sel.dataset.wishlistSize || '0', 10);
        var selected = sel.options[sel.selectedIndex];
        var inventory = parseInt(selected ? selected.dataset.inventory || '0' : '0', 10);
        var isAvailable = selected ? selected.dataset.available === 'true' : false;
        var variantId = sel.value;

        // Update qty dropdown
        var qtySelect = qs('[data-wishlist-qty="' + idx + '"]');
        if (qtySelect) {
          populateQtySelect(qtySelect, inventory, isAvailable);
        }

        // Update add-to-bag variant
        var card = sel.closest('[data-wishlist-card]');
        var addBtn = (card && card.querySelector('[data-wishlist-add="' + idx + '"]')) ||
          qs('[data-wishlist-add="' + idx + '"]');
        var actionBtn = addBtn || (card && card.querySelector('button[disabled]'));
        if (actionBtn) {
          if (isAvailable) {
            actionBtn.dataset.wishlistAdd = String(idx);
            actionBtn.dataset.variantId = variantId;
            actionBtn.disabled = false;
            actionBtn.textContent = wishlistLabels.add;
            actionBtn.classList.remove('bg-grey', 'text-dark-grey', 'cursor-not-allowed');
            actionBtn.classList.add('bg-primary', 'text-light', 'hover:bg-secondary');
          } else {
            actionBtn.disabled = true;
            actionBtn.textContent = wishlistLabels.outOfStock;
            actionBtn.classList.add('bg-grey', 'text-dark-grey', 'cursor-not-allowed');
            actionBtn.classList.remove('bg-primary', 'text-light', 'hover:bg-secondary');
          }
        }

        sel.dataset.currentVariantId = variantId;

        // Re-render pricing for the newly selected variant
        var prod = products[idx] && products[idx].fullProduct;
        if (prod && card) {
          var newVariant = (prod.variants || []).filter(function(v) {
            return String(v.id) === variantId;
          })[0];
          if (newVariant) renderPrice(card, prod, newVariant);
        }
      });
    });

    // Add to bag
    document.querySelectorAll('[data-wishlist-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = parseInt(btn.dataset.variantId || '0', 10);
        var idx = parseInt(btn.dataset.wishlistAdd || '0', 10);
        var qtySelect = qs('[data-wishlist-qty="' + idx + '"]');
        var quantity = qtySelect ? parseInt(qtySelect.value || '1', 10) : 1;

        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = wishlistLabels.adding;

        var productTags = [];
        try { productTags = JSON.parse(btn.dataset.productTags || '[]'); } catch (e) { /* ignore */ }

        addToCart(variantId, quantity, productTags).then(function() {
          btn.textContent = wishlistLabels.added + ' \u2713';
          document.dispatchEvent(new Event('cart:open'));

          setTimeout(function() {
            btn.textContent = wishlistLabels.add;
            btn.disabled = false;
          }, 2000);
        }).catch(function() {
          btn.textContent = wishlistLabels.add;
          btn.disabled = false;
        });
      });
    });

    // Remove
    document.querySelectorAll('[data-wishlist-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var empi = parseInt(btn.dataset.empi || '0', 10);
        var epi = parseInt(btn.dataset.epi || '0', 10);
        var du = btn.dataset.du || '';
        var card = btn.closest('[data-wishlist-card]');

        // Optimistic UI
        if (card) card.style.opacity = '0.5';

        var swat = window._swat;
        if (swat) {
          swat.removeFromWishList(
            { et: 4, epi: epi, empi: empi, du: du },
            function() {
              products = products.filter(function(p) { return p.empi !== empi; });
              document.dispatchEvent(new CustomEvent('swym:wishlist-updated'));
              render();
            },
            function() {
              // Revert on failure
              if (card) card.style.opacity = '1';
            }
          );
        }
      });
    });
  }

  function setupShareLinks() {
    var emailBtn = qs('[data-wishlist-share-email]');
    var twitterBtn = qs('[data-wishlist-share-twitter]');
    var facebookBtn = qs('[data-wishlist-share-facebook]');

    if (emailBtn) {
      emailBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var link = shareLink || window.location.href;
        window.location.href = 'mailto:?subject=Check%20my%20wishlist&body=' + encodeURIComponent(link);
      });
    }

    if (twitterBtn) {
      twitterBtn.addEventListener('click', function() {
        var link = shareLink || window.location.href;
        window.open('https://twitter.com/home?status=' + encodeURIComponent(link), 'twitter-popup', 'height=400,width=600');
      });
    }

    if (facebookBtn) {
      facebookBtn.addEventListener('click', function() {
        var link = shareLink || window.location.href;
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link), 'facebook-popup', 'height=400,width=600');
      });
    }
  }

  // --- Init ---

  var wishlistLabels = {};

  function init() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    wishlistLabels = {
      add: page.dataset.labelAdd || 'Add to bag',
      adding: page.dataset.labelAdding || 'Adding...',
      added: page.dataset.labelAdded || 'Added',
      outOfStock: page.dataset.labelOutOfStock || 'Out Of Stock!'
    };

    discountActive = page.dataset.discountActive === 'true';
    discountTag = page.dataset.discountTag || '';
    discountLabel = page.dataset.discountLabel || '';
    discountAmount = parseFloat(page.dataset.discountAmount || '0') || 0;

    var swat = window._swat;
    if (!swat) {
      setTimeout(init, 500);
      return;
    }

    // Fetch wishlist items
    swat.fetch(function(items) {
      if (!items || items.length === 0) {
        products = [];
        render();
        return;
      }

      // Fetch full product data for each item
      Promise.all(
        items.map(function(item) {
          return fetchProductByUrl(item.du).then(function(fullProduct) {
            if (fullProduct) {
              item.fullProduct = fullProduct;
              if (!(item.cprops && item.cprops.variants) && fullProduct.variants) {
                item.cprops = {
                  variants: fullProduct.variants.map(function(v) {
                    return {
                      id: v.id,
                      inventory_quantity: v.inventory_quantity,
                      available: v.available,
                      title: v.title,
                    };
                  }),
                };
              }
            }
            return item;
          });
        })
      ).then(function(fullProducts) {
        products = fullProducts.filter(function(p) { return p.fullProduct; });
        render();
      });
    });

    // Generate share link
    swat.generateSharedListURL(null, function(response) {
      shareLink = response;
    });

    setupShareLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page"]) return;
  try {
    
  (function() {
    var content = document.getElementById('generic-content');
    var sidebar = document.getElementById('page-sidebar');
    if (!content || !sidebar) return;

    // Collect headings from page content (h1 or h2, excluding the page title heading)
    var headings = [];
    var h1s = content.querySelectorAll('h1');
    if (h1s.length > 0) {
      headings = Array.prototype.slice.call(h1s);
    } else {
      headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    }

    // Build sidebar TOC
    headings.forEach(function(heading, i) {
      var tocItem = document.createElement('div');
      tocItem.className = 'text-primary border-b py-0-6 mt-0-8 cursor-pointer';
      var span = document.createElement('span');
      span.className = 'text-sm font-medium tracking-widest leading-looser uppercase';
      span.textContent = heading.textContent;
      tocItem.appendChild(span);
      tocItem.addEventListener('click', function() {
        var nextSibling = heading.nextElementSibling;
        if (nextSibling) {
          window.scrollTo(0, nextSibling.offsetTop - 144);
        }
      });
      sidebar.appendChild(tocItem);
    });

    // Mobile: toggle next sibling paragraphs on heading click
    function getNextParagraphs(el) {
      var siblings = [];
      var next = el.nextElementSibling;
      while (next && next.nodeName === 'P') {
        siblings.push(next);
        next = next.nextElementSibling;
      }
      return siblings;
    }

    headings.forEach(function(heading) {
      var pList = getNextParagraphs(heading);
      heading.addEventListener('click', function() {
        if (window.innerWidth >= 767) return;
        var isOpen = heading.classList.contains('nextSiblingOpened');
        pList.forEach(function(p) {
          p.style.display = isOpen ? 'none' : 'block';
        });
        if (isOpen) {
          heading.classList.remove('nextSiblingOpened');
        } else {
          heading.classList.add('nextSiblingOpened');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-password"]) return;
  try {
    
  (function() {
    var main = document.getElementById('password-main');
    var popup = document.getElementById('password-popup');
    var showBtn = document.getElementById('password-show-btn');
    var hideBtn = document.getElementById('password-hide-btn');
    var hideBtnMobile = document.getElementById('password-hide-btn-mobile');
    var passwordInput = document.getElementById('password-input');

    if (!main || !popup) return;

    function showPopup(e) {
      if (e) e.preventDefault();
      popup.classList.remove('invisible');
      popup.classList.add('visible');
      main.style.transform = 'translateY(-100%)';
      setTimeout(function() { passwordInput && passwordInput.focus(); }, 300);
    }

    function hidePopup(e) {
      if (e) e.preventDefault();
      popup.classList.remove('visible');
      popup.classList.add('invisible');
      main.style.transform = 'translateY(0)';
    }

    if (showBtn) showBtn.addEventListener('click', showPopup);
    if (hideBtn) hideBtn.addEventListener('click', hidePopup);
    if (hideBtnMobile) hideBtnMobile.addEventListener('click', hidePopup);

    // Auto-show popup if there are form errors
    if (popup.querySelector('.animation-errors')) {
      showPopup();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product"]) return;
  try {
    

(function() {
  var Gazman = window.Gazman || {};

  var RECENTLY_VIEWED_KEY = 'theme:products:recently-viewed';
  var MAX_RECENT = 6;

  var variants = [];
  var productMeta = null;
  var currentVariant = null;
  var selectedOptions = {};
  var desktopSplide = null;
  var mobileSplide = null;
  var variantSelected = false;

  // --- Helpers ---

  function parseJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '');
    } catch (e) {
      return null;
    }
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  // --- Variant Logic ---

  function findVariant(opts) {
    return variants.find(
      function(v) { return v.option1 === opts.option1 && v.option2 === opts.option2 && v.option3 === opts.option3; }
    ) || null;
  }

  function findVariantById(id) {
    return variants.find(function(v) { return v.id === id; }) || null;
  }

  function getOptionsFromVariant(v) {
    return { option1: v.option1, option2: v.option2, option3: v.option3 };
  }

  function isPreorder(v) {
    return v.inventory_quantity < 1 && v.inventory_policy === 'continue';
  }

  // --- Section Rendering API ---

  function swapElement(selector, doc) {
    var newEl = doc.querySelector(selector);
    var currentEl = document.querySelector(selector);
    if (newEl && currentEl) {
      currentEl.innerHTML = newEl.innerHTML;
      currentEl.className = newEl.className;
    }
  }

  var preezieEnhanceAttempts = 0;
  var preezieEnhanceQueued = false;
  var preezieEnhanceTimer = null;

  function markPreezieSuggestionButtons(root) {
    qsa('button', root).forEach(function(button) {
      var label = (button.textContent || '').trim();
      if (label && label !== 'Find Similar') {
        button.setAttribute('data-gazman-preezie-suggestion', 'true');
      }
    });
  }

  function injectPreezieStyles(root) {
    if (root.querySelector('style[data-gazman-preezie-styles]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-gazman-preezie-styles', '');
    style.textContent = [
      '[data-gazman-preezie-suggestion] { background: #edf3f6 !important; color: #002144 !important; border-color: #d3dde4 !important; }',
      '[data-gazman-preezie-suggestion]:hover, [data-gazman-preezie-suggestion]:focus-visible { background: #e3edf3 !important; color: #002144 !important; }'
    ].join('');
    root.appendChild(style);
  }

  function enhancePreezieWidget() {
    var enhanced = false;
    qsa('[id^="preezie-ai-widget-id"]').forEach(function(host) {
      if (!host.shadowRoot) return;

      var root = host.shadowRoot;
      enhanced = true;
      injectPreezieStyles(root);
      markPreezieSuggestionButtons(root);

      if (root._gazmanPreezieObserver) return;

      root._gazmanPreezieObserver = new MutationObserver(function() {
        markPreezieSuggestionButtons(root);
      });
      root._gazmanPreezieObserver.observe(root, { childList: true, subtree: true });
    });
    return enhanced;
  }

  function queuePreezieEnhancements() {
    if (preezieEnhanceQueued) return;
    preezieEnhanceQueued = true;
    window.requestAnimationFrame(function() {
      preezieEnhanceQueued = false;
      var enhanced = enhancePreezieWidget();
      if (enhanced) {
        preezieEnhanceAttempts = 0;
        return;
      }
      if (preezieEnhanceAttempts >= 40) return;
      preezieEnhanceAttempts += 1;
      window.clearTimeout(preezieEnhanceTimer);
      preezieEnhanceTimer = window.setTimeout(queuePreezieEnhancements, 250);
    });
  }

  function initPreezieEnhancements() {
    preezieEnhanceAttempts = 0;
    queuePreezieEnhancements();
  }

  function swapAddToCartWrapper(doc) {
    var newEl = doc.querySelector('[data-addtocart-wrapper]');
    var currentEl = qs('[data-addtocart-wrapper]');
    if (!newEl || !currentEl) return;

    var preezieWrapper = qs('[data-preezie-wrapper]', currentEl);
    if (!preezieWrapper) {
      swapElement('[data-addtocart-wrapper]', doc);
      queuePreezieEnhancements();
      return;
    }

    var newPreezieWrapper = qs('[data-preezie-wrapper]', newEl);
    if (newPreezieWrapper) newPreezieWrapper.remove();

    currentEl.className = newEl.className;
    Array.from(currentEl.childNodes).forEach(function(node) {
      if (node !== preezieWrapper) node.remove();
    });
    Array.from(newEl.childNodes).forEach(function(node) {
      currentEl.insertBefore(document.importNode(node, true), preezieWrapper);
    });
    queuePreezieEnhancements();
  }

  function rebindAfterSwap() {
    // Re-bind afterpay lightbox (direct element listeners lost on DOM swap)
    initAfterpay();

    // Re-bind qty display sync
    var qtySel = qs('[data-qty-select]');
    if (qtySel) {
      qtySel.addEventListener('change', function() {
        var display = qs('[data-qty-display]');
        if (display) display.textContent = qtySel.value;
      });
    }
  }

  function resetButton() {
    // After add-to-cart, reset button text to match current variant state
    var btn = qs('[data-addtocart-button]');
    var textEl = qs('[data-addtocart-text]');
    if (!btn || !textEl || !currentVariant) return;

    if (!currentVariant.available && currentVariant.inventory_policy !== 'continue') {
      textEl.textContent = 'Add to Bag';
      btn.disabled = true;
    } else if (currentVariant.inventory_quantity < 1 && currentVariant.inventory_policy === 'continue') {
      textEl.textContent = 'Pre-order';
      btn.disabled = false;
    } else {
      textEl.textContent = 'Add to Bag';
      btn.disabled = false;
    }
  }

  // Optimistically flip the Add to Cart button + qty selector to match the
  // selected variant immediately, without waiting for the section render.
  // Mirrors the server states in snippets/product-addtocart.liquid; the later
  // section swap reconciles with identical markup, so there is no flash.
  var ATC_ENABLED_CLASSES = ['bg-brand', 'border-brand', 'text-light', 'hover:bg-brand-dark', 'hover:border-brand-dark', 'hover:text-light', 'hover-border-group'];
  var ATC_DISABLED_CLASSES = ['bg-grey', 'border-grey', 'text-primary', 'cursor-not-allowed'];

  function updateAddToCartButton(v) {
    var btn = qs('[data-addtocart-button]');
    var textEl = qs('[data-addtocart-text]');
    if (!btn || !textEl || !v) return;

    var preorder = isPreorder(v);
    if (preorder) {
      textEl.textContent = 'Pre-order';
      btn.disabled = false;
    } else if (!v.available) {
      textEl.textContent = 'Add to Bag';
      btn.disabled = true;
    } else {
      textEl.textContent = 'Add to Bag';
      btn.disabled = false;
    }

    var add = btn.disabled ? ATC_DISABLED_CLASSES : ATC_ENABLED_CLASSES;
    var remove = btn.disabled ? ATC_ENABLED_CLASSES : ATC_DISABLED_CLASSES;
    remove.forEach(function(c) { btn.classList.remove(c); });
    add.forEach(function(c) { btn.classList.add(c); });
  }

  function updateQtyEnabled(v) {
    var sel = qs('[data-qty-select]');
    var wrap = qs('[data-qty-wrapper]');
    var disabled = !v.available && !isPreorder(v);
    if (sel) sel.disabled = disabled;
    if (wrap) {
      wrap.classList.toggle('bg-grey', disabled);
      wrap.classList.toggle('pointer-events-none', disabled);
      wrap.classList.toggle('bg-transparent', !disabled);
    }
  }

  function highlightSelectedOptions() {
    // Immediate visual feedback for option buttons before section render
    qsa('[data-option-value]').forEach(function(btn) {
      var value = btn.dataset.optionValue;
      var index = parseInt(btn.dataset.optionIndex, 10);
      var key = 'option' + index;
      var isSelected = variantSelected && selectedOptions[key] === value;
      var isDisabled = btn.dataset.disabled === 'true';

      btn.classList.remove(
        'bg-brand', 'text-light', 'border-brand',
        'bg-transparent', 'bg-grey', 'text-primary', 'border-grey', 'hover:bg-grey'
      );

      if (isDisabled) {
        btn.classList.add('bg-grey', 'text-primary', 'border-grey');
      } else if (isSelected) {
        btn.classList.add('bg-brand', 'text-light', 'border-brand');
      } else {
        btn.classList.add('bg-transparent', 'text-primary', 'border-grey');
      }
    });

    // Update select dropdowns and heading displays
    qsa('[data-option-select]').forEach(function(sel) {
      var index = parseInt(sel.dataset.optionIndex, 10);
      var key = 'option' + index;
      if (selectedOptions[key]) {
        sel.value = selectedOptions[key];
        var container = sel.closest('[data-option-values]');
        var display = container ? container.querySelector('[data-option-display]') : null;
        if (display) display.textContent = selectedOptions[key];
      }
    });

    qsa('[data-option-group]').forEach(function(group) {
      var index = parseInt(group.dataset.optionIndex || '0', 10);
      var key = 'option' + index;
      var display = qs('[data-option-selected-value]', group);
      if (display) {
        display.textContent = variantSelected && selectedOptions[key] ? selectedOptions[key] : '';
      }
    });
  }

  function updateURL(v) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(v.id));
    history.replaceState(null, '', url.toString());
  }

  function updateHiddenInput(v) {
    var input = qs('[data-variant-id-input]');
    if (input) input.value = String(v.id);
  }

  function scrollGalleryToVariant(v) {
    if (!v.featured_image_position) return;
    var slideIndex = v.featured_image_position - 1;
    if (desktopSplide && slideIndex >= 0) {
      desktopSplide.go(slideIndex);
    }
    if (mobileSplide && slideIndex >= 0) {
      mobileSplide.go(slideIndex);
    }
  }

  // Hide Click & Collect when the selected variant is out of stock (matches live);
  // Find in Store stays and expands to full width. The FIS/C&C row lives outside
  // [data-addtocart-wrapper], so it is not touched by the section-render swap.
  function updateClickCollectVisibility() {
    var ccBtn = qs('[data-click-collect-trigger]');
    if (!ccBtn) return;
    var ccWrap = ccBtn.parentNode;
    var oos = currentVariant && !currentVariant.available && currentVariant.inventory_policy !== 'continue';
    ccWrap.classList.toggle('hidden', !!oos);
    var fisBtn = qs('[data-find-in-store-trigger]');
    if (fisBtn) {
      var fisWrap = fisBtn.parentNode;
      fisWrap.classList.toggle('w-1/2', !oos);
      fisWrap.classList.toggle('w-full', !!oos);
    }
  }

  function onVariantChange(v, scrollGallery) {
    if (scrollGallery === undefined) scrollGallery = true;
    currentVariant = v;
    selectedOptions = getOptionsFromVariant(v);

    // Client-only immediate updates
    updateURL(v);
    updateHiddenInput(v);
    highlightSelectedOptions();
    updateClickCollectVisibility();
    updateAddToCartButton(v);
    updateQtyEnabled(v);
    if (scrollGallery) scrollGalleryToVariant(v);

    // Server-rendered update via Section Rendering API
    var pageEl = qs('[data-product-page]');
    var sectionWrapper = pageEl ? pageEl.closest('[id^="shopify-section-"]') : null;
    var sectionName = sectionWrapper ? sectionWrapper.id.replace('shopify-section-', '') : 'template-product';
    fetch(window.location.pathname + '?variant=' + v.id + '&sections=' + sectionName)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var html = data[sectionName];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        swapElement('[data-price-wrapper]', doc);
        swapElement('[data-afterpay-area]', doc);
        swapElement('[data-product-options]', doc);
        swapElement('[data-inventory-area]', doc);
        swapAddToCartWrapper(doc);
        swapElement('[data-restock-form]', doc);

        rebindAfterSwap();
        highlightSelectedOptions();
        updateClickCollectVisibility();
      });

    // GTM
    fireProductDetailGTM();

    // Wishlist check
    checkWishlistStatus();
  }

  // --- Option Handling ---

  function handleOptionClick(e) {
    var target = e.target.closest('[data-option-value]');
    if (!target) return;

    var value = target.dataset.optionValue;
    var index = parseInt(target.dataset.optionIndex, 10);
    var key = 'option' + index;

    selectedOptions[key] = value;
    variantSelected = true;

    var v = findVariant(selectedOptions);
    if (v) {
      onVariantChange(v);
    }
  }

  function handleOptionSelect(e) {
    var target = e.target;
    if (!target.hasAttribute('data-option-select')) return;

    var index = parseInt(target.dataset.optionIndex, 10);
    var key = 'option' + index;
    selectedOptions[key] = target.value;
    variantSelected = true;

    // Update visible display text for custom dropdown
    var container = target.closest('[data-option-values]');
    var display = container ? container.querySelector('[data-option-display]') : null;
    if (display) display.textContent = target.value;

    var v = findVariant(selectedOptions);
    if (v) {
      onVariantChange(v);
    }
  }

  function handleFindStoreVariantChange(e) {
    var detail = e.detail || {};
    var variantId = parseInt(detail.variantId || '0', 10);
    if (!variantId) return;

    var v = findVariantById(variantId);
    if (!v) return;

    variantSelected = true;
    onVariantChange(v, false);
  }

  // --- Add to Cart ---

  function isGiftCardProduct() {
    return !!(productMeta && productMeta.is_gift_card);
  }

  function handleAddToCart(e) {
    e.preventDefault();

    if (!currentVariant || !variantSelected) {
      var errorEl = qs('[data-addtocart-error]');
      if (errorEl) {
        errorEl.textContent = 'Please select a size';
        errorEl.classList.remove('hidden');
      }
      return;
    }

    if (!currentVariant.available && !isPreorder(currentVariant)) return;

    // Gift cards collect recipient details via a modal before adding to cart.
    if (isGiftCardProduct()) {
      openGiftcardRecipientPopup();
      return;
    }

    performAddToCart();
  }

  function performAddToCart(extraProperties) {
    var btn = qs('[data-addtocart-button]');
    var textEl = qs('[data-addtocart-text]');
    var errorEl = qs('[data-addtocart-error]');
    if (!btn || !textEl) return;

    // Clear previous errors
    if (errorEl) {
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
    }

    // State: Adding
    textEl.textContent = 'Adding to Bag...';
    btn.disabled = true;

    var qtySel = qs('[data-qty-select]');
    var qty = parseInt((qtySel && qtySel.value) || '1', 10);

    var properties = (Gazman.buildDiscountProperties && productMeta) ? Gazman.buildDiscountProperties(productMeta.tags) : null;
    if (extraProperties) {
      properties = properties || {};
      Object.keys(extraProperties).forEach(function(key) {
        properties[key] = extraProperties[key];
      });
    }

    Gazman.addToCart(currentVariant.id, qty, properties || undefined)
    .then(function() {
      // GTM addToCart
      if (Gazman.gtm && productMeta) {
        Gazman.gtm.trackAddToCart(productMeta, currentVariant, qty);
      }

      // The cart drawer (opened off the same cart:updated event) is the success
      // confirmation, so revert the CTA straight back to its ready state instead
      // of holding "Added" on a timer after the drawer is already open.
      resetButton();
    }).catch(function(err) {
      var errorEl = qs('[data-addtocart-error]');
      if (errorEl) {
        errorEl.textContent = (err && err.message) || 'Error adding item to cart';
        errorEl.classList.remove('hidden');
      }
      resetButton();
    });
  }

  // --- Gallery (Splide) ---

  function initGallery() {
    var mainEl = qs('[data-gallery-main]');
    var mobileEl = qs('[data-gallery-mobile]');

    if (mainEl) {
      desktopSplide = new Splide(mainEl, {
        type: 'slide',
        perPage: 1,
        arrows: false,
        pagination: false,
        speed: 500,
        drag: true,
      });

      desktopSplide.on('move', function(newIndex) {
        updateThumbnailActive(newIndex);
      });

      desktopSplide.mount();
    }

    if (mobileEl) {
      mobileSplide = new Splide(mobileEl, {
        type: 'loop',
        perPage: 1,
        arrows: false,
        pagination: true,
        speed: 500,
        drag: true,
        classes: {
          pagination: 'splide__pagination block md:hidden',
        },
      });

      mobileSplide.mount();
    }

    // Thumbnail clicks (plain divs, not Splide)
    qsa('[data-gallery-thumb-btn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var index = parseInt(btn.dataset.slideIndex || '0', 10);
        if (desktopSplide) desktopSplide.go(index);
        updateThumbnailActive(index);
      });
    });
  }

  function updateThumbnailActive(activeIndex) {
    qsa('[data-gallery-thumb-btn]').forEach(function(thumb) {
      if (parseInt(thumb.dataset.slideIndex || '0', 10) === activeIndex) {
        thumb.classList.remove('border-transparent', 'hover:border-grey');
        thumb.classList.add('border-brand');
      } else {
        thumb.classList.remove('border-brand');
        thumb.classList.add('border-transparent', 'hover:border-grey');
      }
    });
  }

  // --- Image Zoom ---

  function initDesktopZoom() {
    qsa('[data-zoom-container]').forEach(function(container) {
      var img = qs('[data-zoom-image]', container);
      if (!img) return;

      var lens = document.createElement('div');
      var preview = document.createElement('div');
      var zoomTarget = document.getElementById('product-zoom-lens');
      var frame = null;
      var active = false;

      lens.className = 'product-zoom-lens';
      preview.className = 'product-zoom-preview';

      function preloadZoomImage() {
        var highResSrc = img.dataset.zoomPreviewSrc || img.dataset.zoomSrc;
        if (!highResSrc || img.dataset.zoomLoadedSrc || img.dataset.zoomLoadingSrc === highResSrc) return;

        img.dataset.zoomLoadingSrc = highResSrc;
        var highResImage = new Image();
        highResImage.onload = function() {
          img.dataset.zoomLoadedSrc = highResImage.src;
        };
        highResImage.src = highResSrc;
      }

      function hideZoom() {
        active = false;
        img.style.cursor = '';
        if (lens.parentNode) lens.parentNode.removeChild(lens);
        if (preview.parentNode) preview.parentNode.removeChild(preview);
      }

      function updateZoom(e) {
        var rect = container.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var outside = x < 20 || y < 20 || x > rect.width - 20 || y > rect.height - 20;

        if (outside) {
          hideZoom();
          return;
        }

        active = true;
        img.style.cursor = 'none';

        if (!lens.parentNode) container.appendChild(lens);
        if (zoomTarget && !preview.parentNode) zoomTarget.appendChild(preview);

        var lensWidth = 140;
        var lensHeight = 230;
        var halfLensWidth = lensWidth / 2;
        var halfLensHeight = lensHeight / 2;
        var lensTop = Math.floor(y + halfLensHeight > rect.height ? rect.height - lensHeight : y - halfLensHeight < 0 ? 0 : y - halfLensHeight);
        var lensLeft = Math.floor(x + halfLensWidth > rect.width ? rect.width - lensWidth : x - halfLensWidth < 0 ? 0 : x - halfLensWidth);

        lens.style.top = lensTop + 'px';
        lens.style.left = lensLeft + 'px';
        lens.style.width = lensWidth + 'px';
        lens.style.height = lensHeight + 'px';

        var lensSizeX = rect.width / 2;
        var lensSizeY = (rect.height * 2) / 3;
        var previewWidth = lensSizeX * 1.2;
        var previewHeight = lensSizeY * 1.2;
        var scaleX = previewWidth / lensWidth;
        var scaleY = previewHeight / lensHeight;
        var zoomSrc = img.dataset.zoomLoadedSrc || img.currentSrc || img.src || img.dataset.zoomPreviewSrc || img.dataset.zoomSrc;

        preview.style.width = previewWidth + 'px';
        preview.style.height = previewHeight + 'px';
        preview.style.backgroundImage = 'url("' + zoomSrc + '")';
        preview.style.backgroundPosition = '-' + (lensLeft * scaleX) + 'px -' + (lensTop * scaleY) + 'px';
        preview.style.backgroundSize = (rect.width * scaleX) + 'px ' + (rect.height * scaleY) + 'px';
        preview.style.transform = 'translate(-40px, -100px)';
      }

      container.addEventListener('mouseenter', function(e) {
        preloadZoomImage();
        updateZoom(e);
      });

      container.addEventListener('mousemove', function(e) {
        if (frame) window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(function() {
          updateZoom(e);
          frame = null;
        });
      });

      container.addEventListener('mouseleave', function() {
        if (frame) window.cancelAnimationFrame(frame);
        frame = null;
        if (active) hideZoom();
      });
    });
  }

  function initMobileZoom() {
    qsa('[data-zoom-container-mobile]').forEach(function(container) {
      var img = qs('[data-zoom-image-mobile]', container);
      if (!img) return;

      var lastTap = 0;
      var zoomed = false;

      container.addEventListener('touchend', function(e) {
        var now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          zoomed = !zoomed;
          if (zoomed) {
            var touch = e.changedTouches[0];
            var rect = container.getBoundingClientRect();
            var x = ((touch.clientX - rect.left) / rect.width) * 100;
            var y = ((touch.clientY - rect.top) / rect.height) * 100;
            img.style.transform = 'scale(2.5)';
            img.style.transformOrigin = x + '% ' + y + '%';
          } else {
            img.style.transform = '';
            img.style.transformOrigin = '';
          }
        }
        lastTap = now;
      });
    });
  }

  // --- Accordion ---

  function initAccordion() {
    qsa('[data-accordion-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('[data-accordion-item]');
        if (!item) return;

        var content = qs('[data-accordion-content]', item);
        var icon = btn.querySelector('svg, [class*="rotate"]');
        var expanded = btn.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          if (content) {
            content.classList.remove('opacity-100', 'max-h-none', 'visible');
            content.classList.add('opacity-0', 'max-h-0', 'invisible');
          }
          if (icon) {
            icon.classList.remove('rotate:180');
            icon.classList.add('rotate:0');
          }
          item.classList.remove('pb-1');
          item.classList.add('pb-0');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          if (content) {
            content.classList.remove('opacity-0', 'max-h-0', 'invisible');
            content.classList.add('opacity-100', 'max-h-none', 'visible');
          }
          if (icon) {
            icon.classList.remove('rotate:0');
            icon.classList.add('rotate:180');
          }
          item.classList.remove('pb-0');
          item.classList.add('pb-1');
        }
      });
    });
  }

  // --- Afterpay Lightbox ---

  function initAfterpay() {
    var learnMore = qs('[data-afterpay-learn-more]');
    var lightbox = qs('[data-afterpay-lightbox]');
    var close = qs('[data-afterpay-lightbox-close]');

    if (!learnMore || !lightbox) return;
    if (learnMore.dataset.afterpayBound === 'true') return;
    learnMore.dataset.afterpayBound = 'true';

    var previousActiveElement = null;
    var previousBodyOverflow = '';

    var openLightbox = function() {
      previousActiveElement = document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      lightbox.classList.remove('hidden');
      lightbox.classList.add('flex');
      document.body.style.overflow = 'hidden';
      if (close) {
        close.focus();
      } else {
        lightbox.focus();
      }
    };

    var closeLightbox = function() {
      lightbox.classList.add('hidden');
      lightbox.classList.remove('flex');
      document.body.style.overflow = previousBodyOverflow;
      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }
    };

    learnMore.addEventListener('click', function(e) {
      e.preventDefault();
      openLightbox();
    });

    if (close) close.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !lightbox.classList.contains('hidden')) closeLightbox();
    });
  }

  // --- Shared Popup Helpers ---

  function openPopup(popup) {
    var overlay = popup.querySelector('[data-size-guide-overlay], [data-find-store-overlay]');
    var content = popup.querySelector('[data-size-guide-content], [data-find-store-content]');

    popup.classList.remove('invisible', 'pointer-events-none');
    popup.classList.add('visible', 'pointer-events-auto');

    if (overlay) {
      overlay.classList.remove('invisible', 'opacity-0', 'transition-fast');
      overlay.classList.add('visible', 'opacity-100', 'transition');
    }

    if (content) {
      content.classList.remove('invisible', 'opacity-0', 'translate-y:20x', 'pointer-events-none', 'transition-fast', 'transition-delay-none');
      content.classList.add('visible', 'opacity-100', 'translate-y:0', 'pointer-events-auto', 'transition', 'transition-delay');
    }

    document.body.style.overflow = 'hidden';
  }

  function closePopup(popup) {
    var overlay = popup.querySelector('[data-size-guide-overlay], [data-find-store-overlay]');
    var content = popup.querySelector('[data-size-guide-content], [data-find-store-content]');

    popup.classList.add('invisible', 'pointer-events-none');
    popup.classList.remove('visible', 'pointer-events-auto');

    if (overlay) {
      overlay.classList.add('invisible', 'opacity-0', 'transition-fast');
      overlay.classList.remove('visible', 'opacity-100', 'transition');
    }

    if (content) {
      content.classList.add('invisible', 'opacity-0', 'translate-y:20x', 'pointer-events-none', 'transition-fast', 'transition-delay-none');
      content.classList.remove('visible', 'opacity-100', 'translate-y:0', 'pointer-events-auto', 'transition', 'transition-delay');
    }

    document.body.style.overflow = '';
  }

  // --- Size Guide Popup ---

  function initSizeGuide() {
    var popup = qs('[data-size-guide-popup]');
    if (!popup) return;

    var overlay = qs('[data-size-guide-overlay]', popup);
    var closeBtn = qs('[data-size-guide-close]', popup);

    var open = function() { openPopup(popup); };
    var close = function() {
      closePopup(popup);
      if (window.location.hash === '#sizing') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    };

    // Trigger buttons
    qsa('[data-size-guide-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        open();
      });
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Click outside modal to close
    var contentEl = qs('[data-size-guide-content]', popup);
    if (contentEl) {
      contentEl.addEventListener('click', function(e) {
        if (e.target === contentEl) close();
      });
    }

    // Hash-based open
    if (window.location.hash === '#sizing') open();
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#sizing') open();
    });

    // Tab switching
    qsa('[data-size-guide-tab]', popup).forEach(function(tab) {
      tab.addEventListener('click', function() {
        var tabName = tab.dataset.sizeGuideTab;
        qsa('[data-size-guide-tab]', popup).forEach(function(t) {
          var isActive = t.dataset.sizeGuideTab === tabName;
          t.classList.toggle('font-medium', isActive);
          t.classList.toggle('text-brand', isActive);
          t.classList.toggle('font-light', !isActive);
          t.classList.toggle('text-primary', !isActive);
        });
        qsa('[data-size-guide-panel]', popup).forEach(function(p) {
          var isActive = p.dataset.sizeGuidePanel === tabName;
          p.classList.toggle('hidden', !isActive);
        });
      });
    });

    // Load measuring diagram
    loadMeasuringDiagram();
  }

  function loadMeasuringDiagram() {
    var diagramEl = qs('[data-measuring-diagram]');
    if (!diagramEl || !productMeta) return;

    var imagesJson = parseJSON('size-guide-images-json');
    if (!imagesJson) return;

    var productType = productMeta.type;

    // Determine which image to show based on product type
    var checks = [
      { key: 'top_image', types: imagesJson.top_image_types },
      { key: 'bottom_image', types: imagesJson.bottom_image_types },
      { key: 'shoe_image', types: imagesJson.shoe_image_types },
    ];

    for (var c = 0; c < checks.length; c++) {
      var check = checks[c];
      if (!check.types || !imagesJson[check.key]) continue;
      var typeList = check.types.split(',').map(function(s) { return s.trim().toLowerCase(); });
      if (typeList.includes(productType.toLowerCase())) {
        diagramEl.innerHTML = '<img src="' + imagesJson[check.key] + '" alt="Measuring guide" class="w-full h-auto" loading="lazy" />';
        return;
      }
    }
  }

  // --- Find in Store ---

  function initFindInStore() {
    var fisBtn = qs('[data-find-in-store-trigger]');
    var ccBtn = qs('[data-click-collect-trigger]');
    var popup = qs('[data-find-store-popup]');

    if (!popup || (!fisBtn && !ccBtn)) return;

    var open = function(isClickCollect) {
      popup.dataset.mode = isClickCollect ? 'click-collect' : 'find-in-store';
      var titleEl = qs('[data-find-store-title]', popup);
      if (titleEl) titleEl.textContent = isClickCollect ? 'Click & Collect' : 'Find in Store';
      openPopup(popup);

      document.dispatchEvent(new CustomEvent('find-store:init', {
        detail: {
          popup: popup,
          variants: variants,
          currentVariant: currentVariant,
          variantSelected: variantSelected,
          productMeta: productMeta,
          isClickCollect: isClickCollect,
        },
      }));
    };

    var close = function() { closePopup(popup); };

    if (fisBtn) fisBtn.addEventListener('click', function() { open(false); });
    if (ccBtn) ccBtn.addEventListener('click', function() { open(true); });

    var overlay = qs('[data-find-store-overlay]', popup);
    var closeBtn = qs('[data-find-store-close]', popup);
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Click outside modal to close
    var contentEl = qs('[data-find-store-content]', popup);
    if (contentEl) {
      contentEl.addEventListener('click', function(e) {
        if (e.target === contentEl) close();
      });
    }
  }

  // --- Wishlist (Swym) ---

  var isInWishlist = false;

  function checkWishlistStatus() {
    if (!window._swat || !currentVariant) return;

    var swat = window._swat;
    var SwymPageData = window.SwymPageData;
    if (!SwymPageData) return;

    swat.fetch(function(products) {
      isInWishlist = products.some(
        function(p) { return p.epi === currentVariant.id; }
      );
      updateWishlistUI();
    });
  }

  function updateWishlistUI() {
    var linkText = qs('[data-wishlist-link-text]');
    if (linkText) {
      linkText.textContent = isInWishlist ? 'Remove from' : 'Add to';
    }

    // Update star icon in gallery
    var star = qs('[data-wishlist-toggle]');
    if (star) {
      star.innerHTML = isInWishlist
        ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="text-navy"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'
        : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-navy"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
  }

  function toggleWishlist() {
    var swat = window._swat;
    var SwymPageData = window.SwymPageData;
    if (!swat || !SwymPageData || !currentVariant || !productMeta) return;

    SwymPageData.et = 4;
    SwymPageData.epi = currentVariant.id;

    if (!isInWishlist) {
      SwymPageData.cprops = {
        variants: variants.map(function(v) {
          return {
            id: v.id,
            inventory_quantity: v.inventory_quantity,
            title: v.title,
          };
        }),
      };
      swat.addToWishList(SwymPageData, function() {
        isInWishlist = true;
        updateWishlistUI();
        document.dispatchEvent(new CustomEvent('swym:wishlist-updated'));
      });
    } else {
      swat.removeFromWishList(SwymPageData, function() {
        isInWishlist = false;
        updateWishlistUI();
        document.dispatchEvent(new CustomEvent('swym:wishlist-updated'));
      });
    }
  }

  function initWishlist() {
    // Gallery star
    var star = qs('[data-wishlist-toggle]');
    if (star) star.addEventListener('click', toggleWishlist);

    // Text link
    var link = qs('[data-wishlist-link]');
    if (link) link.addEventListener('click', toggleWishlist);

    // Initial check with retry
    var tryCheck = function() {
      if (window._swat) {
        checkWishlistStatus();
      } else {
        setTimeout(tryCheck, 1000);
      }
    };
    tryCheck();
  }

  // --- Recently Viewed ---

  function trackRecentlyViewed() {
    if (!productMeta || !currentVariant) return;

    var key = productMeta.id + ':' + currentVariant.id;
    var recent = [];

    try {
      var stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      recent = stored ? stored.split(',').filter(Boolean) : [];
    } catch (e) {
      return;
    }

    // Remove if already present, add to end
    var idx = recent.indexOf(key);
    if (idx > -1) recent.splice(idx, 1);
    recent.push(key);

    // Keep max
    if (recent.length > MAX_RECENT) recent = recent.slice(-MAX_RECENT);

    try {
      localStorage.setItem(RECENTLY_VIEWED_KEY, recent.join(','));
    } catch (e) {
      // Quota exceeded -- ignore
    }
  }

  // --- GTM ---

  function fireProductDetailGTM() {
    if (!Gazman.gtm || !productMeta || !currentVariant) return;

    var colour = '';
    var colourTag = productMeta.tags.find(function(t) { return t.startsWith('x-colour:'); });
    if (colourTag) colour = colourTag.split(':')[1] || '';

    var sale = currentVariant.compare_at_price > currentVariant.price ? 'Sale' : '';
    var discount = productMeta.tags.find(function(t) { return t.includes('flag:'); });
    if (discount) {
      var offer = discount.split('flag:')[1];
      sale = sale ? sale + ' | ' + offer : offer;
    }

    var impression = {
      name: productMeta.title,
      id: currentVariant.sku,
      price: (currentVariant.price / 100).toFixed(2),
      brand: productMeta.vendor,
      category: productMeta.type,
      variant: colour,
      dimension11: currentVariant.title,
      dimension12: currentVariant.available ? 'In Stock' : 'Out of Stock',
      dimension13: sale,
    };

    var currency = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency) || 'AUD';
    Gazman.gtm.trackProductDetail(impression, currency, 'Product Details');
  }

  // --- Restock Form Submit ---

  function initRestockForm() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-restock-submit]');
      if (!form) return;
      e.preventDefault();

      var formData = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then(function(res) {
          var successEl = document.getElementById('dd-restock-notification-msg-success');
          var errorEl = document.getElementById('dd-restock-notification-msg-error');
          if (res.ok && successEl) {
            successEl.classList.remove('hidden');
            if (errorEl) errorEl.classList.add('hidden');
          } else if (errorEl) {
            errorEl.classList.remove('hidden');
            if (successEl) successEl.classList.add('hidden');
          }
        })
        .catch(function() {
          var errorEl = document.getElementById('dd-restock-notification-msg-error');
          if (errorEl) errorEl.classList.remove('hidden');
        });
    });
  }

  // --- Gift card recipient popup ---

  function openGiftcardRecipientPopup() {
    var popup = qs('[data-giftcard-recipient-popup]');
    if (!popup) {
      // Fallback: if popup somehow isn't rendered, add directly.
      performAddToCart();
      return;
    }
    var overlay = popup.querySelector('[data-giftcard-recipient-overlay]');
    var content = popup.querySelector('[data-giftcard-recipient-content]');

    popup.classList.remove('invisible', 'pointer-events-none');
    popup.classList.add('visible', 'pointer-events-auto');
    if (overlay) {
      overlay.classList.remove('invisible', 'opacity-0', 'transition-fast');
      overlay.classList.add('visible', 'opacity-100', 'transition');
    }
    if (content) {
      content.classList.remove('invisible', 'opacity-0', 'translate-y:20x', 'pointer-events-none', 'transition-fast', 'transition-delay-none');
      content.classList.add('visible', 'opacity-100', 'translate-y:0', 'pointer-events-auto', 'transition', 'transition-delay');
    }
    document.body.style.overflow = 'hidden';
    var firstInput = popup.querySelector('[data-giftcard-recipient-name]');
    setTimeout(function() { if (firstInput) firstInput.focus(); }, 300);
  }

  function closeGiftcardRecipientPopup() {
    var popup = qs('[data-giftcard-recipient-popup]');
    if (!popup) return;
    var overlay = popup.querySelector('[data-giftcard-recipient-overlay]');
    var content = popup.querySelector('[data-giftcard-recipient-content]');

    popup.classList.add('invisible', 'pointer-events-none');
    popup.classList.remove('visible', 'pointer-events-auto');
    if (overlay) {
      overlay.classList.add('invisible', 'opacity-0', 'transition-fast');
      overlay.classList.remove('visible', 'opacity-100', 'transition');
    }
    if (content) {
      content.classList.add('invisible', 'opacity-0', 'translate-y:20x', 'pointer-events-none', 'transition-fast', 'transition-delay-none');
      content.classList.remove('visible', 'opacity-100', 'translate-y:0', 'pointer-events-auto', 'transition', 'transition-delay');
    }
    document.body.style.overflow = '';
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setRecipientFieldError(input, hasError) {
    if (!input) return;
    if (hasError) {
      input.classList.remove('border-grey');
      input.classList.add('border-red');
    } else {
      input.classList.remove('border-red');
      input.classList.add('border-grey');
    }
  }

  function initGiftcardRecipientPopup() {
    var popup = qs('[data-giftcard-recipient-popup]');
    if (!popup) return;

    var form = qs('#giftcard-recipient-form', popup);
    var overlay = popup.querySelector('[data-giftcard-recipient-overlay]');
    var nameInput = qs('[data-giftcard-recipient-name]', popup);
    var emailInput = qs('[data-giftcard-recipient-email]', popup);
    var fromInput = qs('[data-giftcard-recipient-from]', popup);
    var messageInput = qs('[data-giftcard-recipient-message]', popup);
    var errorEl = qs('[data-giftcard-recipient-error]', popup);
    var submitBtn = qs('#giftcard-recipient-submit', popup);

    qsa('[data-giftcard-recipient-close]', popup).forEach(function(el) {
      el.addEventListener('click', closeGiftcardRecipientPopup);
    });

    if (overlay) overlay.addEventListener('click', closeGiftcardRecipientPopup);

    popup.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeGiftcardRecipientPopup();
    });

    [nameInput, emailInput, fromInput].forEach(function(input) {
      if (!input) return;
      input.addEventListener('focus', function() {
        setRecipientFieldError(input, false);
        if (errorEl) errorEl.classList.add('hidden');
      });
    });

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var nameVal = (nameInput && nameInput.value || '').trim();
        var emailVal = (emailInput && emailInput.value || '').trim();
        var fromVal = (fromInput && fromInput.value || '').trim();
        var messageVal = (messageInput && messageInput.value || '').trim();

        var hasError = false;
        if (!nameVal) { setRecipientFieldError(nameInput, true); hasError = true; }
        if (!emailVal || !isValidEmail(emailVal)) { setRecipientFieldError(emailInput, true); hasError = true; }
        if (!fromVal) { setRecipientFieldError(fromInput, true); hasError = true; }

        if (hasError) {
          if (errorEl) {
            errorEl.textContent = 'Please fill out all required fields with a valid email.';
            errorEl.classList.remove('hidden');
          }
          return;
        }

        if (errorEl) errorEl.classList.add('hidden');

        var properties = {
          name: nameVal,
          email: emailVal,
          from: fromVal,
        };
        if (messageVal) properties.message = messageVal;

        if (submitBtn) submitBtn.disabled = true;

        closeGiftcardRecipientPopup();
        performAddToCart(properties);

        // Re-enable submit so the user can re-open for another add if needed.
        setTimeout(function() {
          if (submitBtn) submitBtn.disabled = false;
        }, 500);
      });
    }
  }

  // --- Init ---

  function init() {
    var page = qs('[data-product-page]');
    if (!page) return;

    // Parse embedded JSON
    variants = parseJSON('product-variants-json') || [];
    productMeta = parseJSON('product-meta-json');

    if (!variants.length || !productMeta) return;

    // Determine initial variant from URL or default
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariantId = parseInt(urlParams.get('variant') || '0', 10);
    currentVariant = (urlVariantId ? findVariantById(urlVariantId) : null)
      || findVariantById(productMeta.selected_variant_id)
      || variants[0];

    selectedOptions = getOptionsFromVariant(currentVariant);

    // For multi-variant products where we need selection. Gift cards always have
    // a default variant pre-selected (Value option) so treat them as ready-to-add.
    var isSelected = productMeta.has_only_default_variant || variants.length === 1 || !!urlVariantId || !!productMeta.is_gift_card;
    variantSelected = isSelected;

    // Init sub-modules (try-catch each to prevent one failure blocking others)
    var modules = [
      ['gallery', initGallery],
      ['desktopZoom', initDesktopZoom],
      ['mobileZoom', initMobileZoom],
      ['accordion', initAccordion],
      ['afterpay', initAfterpay],
      ['preezie', initPreezieEnhancements],
      ['sizeGuide', initSizeGuide],
      ['findInStore', initFindInStore],
      ['wishlist', initWishlist],
      ['restockForm', initRestockForm],
      ['giftcardRecipient', initGiftcardRecipientPopup],
    ];
    for (var m = 0; m < modules.length; m++) {
      try { modules[m][1](); } catch (e) { console.error('[product] ' + modules[m][0] + ' init error:', e); }
    }
    updateClickCollectVisibility();

    // Event listeners
    document.addEventListener('click', handleOptionClick);
    document.addEventListener('change', handleOptionSelect);
    document.addEventListener('find-store:variant-change', handleFindStoreVariantChange);

    // Qty display sync
    var qtySel = qs('[data-qty-select]');
    if (qtySel) {
      qtySel.addEventListener('change', function() {
        var display = qs('[data-qty-display]');
        if (display) display.textContent = qtySel.value;
      });
    }

    // Form submit
    var form = qs('[data-product-form]');
    if (form) form.addEventListener('submit', handleAddToCart);

    // GTM
    fireProductDetailGTM();

    // Recently viewed
    trackRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-register"]) return;
  try {
    
  (function() {
    var acceptTerms = false;
    var acceptMarketing = true;

    var termsToggle = document.querySelector('.register-terms-toggle');
    var termsActive = document.querySelector('.register-terms-active');
    var termsInactive = document.querySelector('.register-terms-inactive');
    var termsError = document.getElementById('register-terms-error');

    var marketingToggle = document.querySelector('.register-marketing-toggle');
    var marketingActive = document.querySelector('.register-marketing-active');
    var marketingInactive = document.querySelector('.register-marketing-inactive');
    var marketingInput = document.getElementById('register-marketing-value');

    var submitBtn = document.getElementById('register-submit-btn');
    var form = submitBtn ? submitBtn.closest('form') : null;

    if (termsToggle) {
      termsToggle.addEventListener('click', function(e) {
        e.preventDefault();
        acceptTerms = !acceptTerms;
        termsActive.classList.toggle('hidden', !acceptTerms);
        termsInactive.classList.toggle('hidden', acceptTerms);
        if (acceptTerms && termsError) termsError.classList.add('hidden');
      });
    }

    if (marketingToggle) {
      marketingToggle.addEventListener('click', function(e) {
        e.preventDefault();
        acceptMarketing = !acceptMarketing;
        marketingActive.classList.toggle('hidden', !acceptMarketing);
        marketingInactive.classList.toggle('hidden', acceptMarketing);
        if (marketingInput) marketingInput.value = acceptMarketing.toString();
      });
    }

    if (submitBtn && form) {
      submitBtn.addEventListener('click', function() {
        if (!acceptTerms) {
          if (termsError) termsError.classList.remove('hidden');
          return;
        }
        if (form.checkValidity()) {
          form.submit();
        } else {
          form.reportValidity();
        }
      });
    }

    var pwField = document.getElementById('register_password');
    var togglePw = document.querySelector('.register-toggle-password');
    var eyeIcon = document.querySelector('.register-icon-eye');
    var noeyeIcon = document.querySelector('.register-icon-noeye');

    if (togglePw && pwField) {
      togglePw.addEventListener('click', function() {
        var isPassword = pwField.type === 'password';
        pwField.type = isPassword ? 'text' : 'password';
        eyeIcon.classList.toggle('hidden', isPassword);
        noeyeIcon.classList.toggle('hidden', !isPassword);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-search"]) return;
  try {
    
  (function() {
    var clearBtn = document.getElementById('searchClear');
    var searchInput = document.getElementById('searchInput');

    if (clearBtn && searchInput) {
      clearBtn.addEventListener('click', function() {
        searchInput.value = '';
        searchInput.focus();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-announcement"]) return;
  try {
    
(function() {
  var CLOSED_KEY = 'theme:announcement:closed';

  function init() {
    var bar = document.getElementById('announcement-bar');
    if (!bar) return;

    // Check if previously closed
    if (localStorage.getItem(CLOSED_KEY)) {
      bar.style.display = 'none';
      return;
    }

    var slides = bar.querySelectorAll('.announcement-slide');
    if (slides.length === 0) return;

    var speed = parseInt(bar.dataset.speed || '5000', 10) || 5000;
    var current = 0;
    var interval = null;

    function showSlide(index) {
      slides.forEach(function(slide, i) {
        slide.classList.toggle('hidden', i !== index);
      });
    }

    function nextSlide() {
      current = (current + 1) % slides.length;
      showSlide(current);
    }

    function prevSlide() {
      current = (current - 1 + slides.length) % slides.length;
      showSlide(current);
    }

    function startRotation() {
      if (slides.length > 1) {
        interval = setInterval(nextSlide, speed);
      }
    }

    function resetRotation() {
      if (interval) clearInterval(interval);
      startRotation();
    }

    // Start auto-rotation
    startRotation();

    // Event delegation for announcement actions
    bar.addEventListener('click', function(e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;

      var action = target.dataset.action;

      if (action === 'close-announcement') {
        e.preventDefault();
        localStorage.setItem(CLOSED_KEY, 'true');
        bar.style.display = 'none';
        if (interval) clearInterval(interval);
      } else if (action === 'announcement-next') {
        e.preventDefault();
        nextSlide();
        resetRotation();
      } else if (action === 'announcement-prev') {
        e.preventDefault();
        prevSlide();
        resetRotation();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-footer"]) return;
  try {
    
(function() {
  function init() {
    // Scroll-to-top visibility
    var scrollBtn = document.getElementById('scroll-to-top');
    var bottom = false;

    if (scrollBtn) {
      window.addEventListener('scroll', function() {
        if (window.pageYOffset > window.innerHeight * 2) {
          bottom = window.pageYOffset + window.innerHeight + 56 > document.body.scrollHeight;
          if (!document.body.classList.contains('template-collection')) {
            scrollBtn.classList.remove('hidden');
            scrollBtn.classList.add('flex');
          }
          if (bottom) {
            scrollBtn.classList.add('mb-5-6', 'md:mb-4-8', 'xxl:mb-1');
            scrollBtn.classList.remove('mb-0-5');
          } else {
            scrollBtn.classList.remove('mb-5-6', 'md:mb-4-8', 'xxl:mb-1');
            scrollBtn.classList.add('mb-0-5');
          }
        } else {
          scrollBtn.classList.add('hidden');
          scrollBtn.classList.remove('flex');
        }
      }, { passive: true });
    }

    // Store locator input - submit on Enter
    var locatorInput = document.querySelector('[data-store-locator-input]');
    if (locatorInput) {
      locatorInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.location.href = '/pages/stores?q=' + encodeURIComponent(locatorInput.value);
        }
      });
    }

    // Event delegation
    document.addEventListener('click', function(e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;

      var action = target.dataset.action;

      // Footer accordion toggle
      if (action === 'footer-accordion') {
        var index = target.dataset.index;
        if (index === undefined) return;

        var content = document.querySelector('[data-footer-accordion="' + index + '"]');
        if (!content) return;

        var isOpen = !content.classList.contains('hidden');

        if (isOpen) {
          content.classList.add('hidden');
          var openIcon = target.querySelector('.footer-accordion-icon-open');
          var closeIcon = target.querySelector('.footer-accordion-icon-close');
          if (openIcon) openIcon.classList.remove('hidden');
          if (closeIcon) closeIcon.classList.add('hidden');
        } else {
          content.classList.remove('hidden');
          var openIcon2 = target.querySelector('.footer-accordion-icon-open');
          var closeIcon2 = target.querySelector('.footer-accordion-icon-close');
          if (openIcon2) openIcon2.classList.add('hidden');
          if (closeIcon2) closeIcon2.classList.remove('hidden');
        }
      }

      // Store locator submit
      if (action === 'store-locator-submit') {
        e.preventDefault();
        var input = document.querySelector('[data-store-locator-input]');
        if (input && input.value) {
          window.location.href = '/pages/stores?q=' + encodeURIComponent(input.value);
        }
      }

      // Scroll to top
      if (action === 'scroll-to-top') {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      // Open subscribe popup
      if (action === 'open-subscribe-popup') {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('subscribe:toggle-popup'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-popups"]) return;
  try {
    
(function() {
  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + value + '; max-age=' + maxAge + '; path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function initPopups() {
    var container = document.getElementById('popups-container');
    if (!container) return;

    var allowMultiple = container.dataset.allowMultiple === 'true';
    var templateName = container.dataset.templateName || '';
    var currentUrl = container.dataset.currentUrl || window.location.pathname;

    var popups = container.querySelectorAll('.popup-item');
    var shownOne = false;

    popups.forEach(function(popup) {
      var id = popup.dataset.popupId || '';
      var location = popup.dataset.popupLocation || '';
      var specificTemplate = popup.dataset.popupTemplate || '';
      var specificUrl = popup.dataset.popupUrl || '';
      var delay = parseInt(popup.dataset.popupDelay || '0', 10);
      var expires = parseInt(popup.dataset.popupExpires || '30', 10);
      var hideMobile = popup.dataset.popupHideMobile === 'true';

      // Check cookie
      var cookieKey = 'popup:' + id;
      var cookieValid = getCookie(cookieKey);

      // If cookie already set, don't show (already seen and not expired)
      if (cookieValid) return;

      // Check if should be hidden on mobile
      if (hideMobile && window.innerWidth < 768) return;

      // Check location match
      var shouldShow = false;
      switch (location) {
        case 'all_pages':
          shouldShow = true;
          break;
        case 'template':
          shouldShow = specificTemplate === templateName;
          break;
        case 'specific':
          shouldShow = specificUrl === currentUrl || (specificUrl === '' && currentUrl === '/');
          break;
        default:
          shouldShow = false;
      }

      if (!shouldShow) return;
      if (!allowMultiple && shownOne) return;

      // Set cookie on display
      setCookie(cookieKey, 'true', expires);

      // Show popup after delay
      setTimeout(function() {
        popup.style.display = '';
        popup.classList.remove('hidden');
      }, delay);

      shownOne = true;
    });
  }

  function initLocationPopup() {
    var popup = document.getElementById('location-popup');
    if (!popup) return;

    var alreadyShown = localStorage.getItem('theme:location-popup-shown');
    if (alreadyShown) return;

    var enabledStates = popup.dataset.enabledStates || '';
    var locationState = popup.dataset.locationState || '';

    if (!locationState) return;

    // Check if current state matches enabled states
    if (enabledStates) {
      var states = enabledStates.split(',').map(function(s) { return s.trim().toUpperCase(); });
      if (!states.includes(locationState.toUpperCase())) return;
    }

    // Show popup
    localStorage.setItem('theme:location-popup-shown', 'true');

    popup.classList.remove('invisible', 'pointer-events-none');
    popup.classList.add('visible', 'pointer-events-auto');

    var inner = popup.querySelector('[data-location-popup-inner]');
    if (inner) {
      inner.classList.remove('invisible', 'opacity-0', 'translate-y:20x', 'pointer-events-none');
      inner.classList.add('visible', 'opacity-100', 'translate-y:0', 'pointer-events-auto');
    }

    var backdrop = inner ? inner.querySelector('.bg-dark') : null;
    if (backdrop) {
      backdrop.classList.remove('invisible', 'opacity-0');
      backdrop.classList.add('visible', 'opacity-50');
    }
  }

  function closeLocationPopup() {
    var popup = document.getElementById('location-popup');
    if (!popup) return;

    localStorage.setItem('theme:location-popup-shown', 'true');
    popup.classList.remove('visible', 'pointer-events-auto');
    popup.classList.add('invisible', 'pointer-events-none');

    var inner = popup.querySelector('[data-location-popup-inner]');
    if (inner) {
      inner.classList.remove('visible', 'opacity-100', 'translate-y:0', 'pointer-events-auto');
      inner.classList.add('invisible', 'opacity-0', 'translate-y:20x', 'pointer-events-none');
    }
  }

  function init() {
    initPopups();
    initLocationPopup();

    // Event delegation for close actions
    document.addEventListener('click', function(e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;

      var action = target.dataset.action;

      if (action === 'close-popup') {
        var popupId = target.dataset.popupClose;
        if (!popupId) return;

        var popup = document.querySelector('[data-popup-id="' + popupId + '"]');
        if (popup) {
          popup.style.display = 'none';
          popup.classList.add('hidden');
        }
      }

      if (action === 'close-location-popup') {
        e.preventDefault();
        closeLocationPopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-subscribe"]) return;
  try {
    
(function() {
  var CLOSED_KEY = 'theme:subscribe:closed';
  var COOKIE_MAX_AGE = 30 * 24 * 60 * 60; // 30 days in seconds

  function setCookie(name, value, maxAge) {
    document.cookie = name + '=' + value + '; max-age=' + maxAge + '; path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function init() {
    var bar = document.getElementById('subscribe-bar');
    var popup = document.getElementById('subscribe-popup');
    if (!bar && !popup) return;

    var popupTrigger = null;

    // Check if bar should be hidden (cookie or page URL match)
    if (bar) {
      var closed = getCookie(CLOSED_KEY);
      if (closed) {
        bar.style.display = 'none';
      }

      // Check hidden URLs
      var hiddenUrls = bar.dataset.hiddenUrls || '';
      if (hiddenUrls) {
        var urls = hiddenUrls.split('|').filter(Boolean);
        var currentPath = window.location.pathname;
        if (urls.some(function(url) { return currentPath.includes(url); })) {
          bar.style.display = 'none';
        }
      }
    }

    // Show popup if form was posted successfully (Liquid already rendered confirmation)
    if (popup) {
      var confirmation = document.getElementById('subscribe-confirmation');
      if (confirmation) {
        popup.classList.remove('hidden');
        popup.classList.add('flex');
        popup.setAttribute('aria-hidden', 'false');
      }
    }

    function openPopup() {
      if (!popup) return;
      popupTrigger = document.activeElement;
      popup.classList.remove('hidden');
      popup.classList.add('flex');
      popup.setAttribute('aria-hidden', 'false');
      if (bar) bar.style.display = 'none';

      // A11y: move focus into popup
      var closeBtn = popup.querySelector('[data-action="close-subscribe-popup"]');
      if (closeBtn) { setTimeout(function() { closeBtn.focus(); }, 100); }
    }

    function closePopup() {
      if (!popup) return;
      popup.classList.add('hidden');
      popup.classList.remove('flex');
      popup.setAttribute('aria-hidden', 'true');
      // Show bar again unless it was closed via cookie
      if (bar && !getCookie(CLOSED_KEY)) {
        bar.style.display = '';
      }

      // A11y: return focus
      if (popupTrigger && popupTrigger.focus) {
        popupTrigger.focus();
        popupTrigger = null;
      }
    }

    // A11y: Escape closes popup
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup && !popup.classList.contains('hidden')) {
        closePopup();
      }
    });

    // A11y: focus trap
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab' || !popup || popup.classList.contains('hidden')) return;
      var focusable = popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Listen for events from footer "Join the newsletter" links
    document.addEventListener('subscribe:toggle-popup', function() {
      if (popup && popup.classList.contains('hidden')) {
        openPopup();
      } else {
        closePopup();
      }
    });

    // Event delegation
    document.addEventListener('click', function(e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;

      var action = target.dataset.action;

      if (action === 'close-subscribe-bar') {
        e.preventDefault();
        setCookie(CLOSED_KEY, 'true', COOKIE_MAX_AGE);
        if (bar) bar.style.display = 'none';
      }

      if (action === 'open-subscribe-popup') {
        e.preventDefault();
        openPopup();
      }

      if (action === 'close-subscribe-popup') {
        e.preventDefault();
        closePopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
